/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
	AIAlgoExecutionFile400ResponseV1,
	AIAlgoSandboxV1,
	AIAlgoSubmissionV1,
	AIAlgoTemplates400ResponseV1,
	AIAlgoTemplates422ResponseV1,
	AIAlgoTemplatesSpecV1,
	AIDialogStatusV1,
	AIInterviewAlreadyExistsErrorV1,
	AIOutboxEventsResponseV1,
	AIOutboxStatusV1,
	AIOutboxValidationFailedResponseV1,
	AIProblemSelectionTagsUpdateV1,
	AIProblemSelectionTagsV1,
	AIProblemTagsReplaceV1,
	AIProblemTagsV1,
	AIProblemTypeV1,
	AIVisibleMessageV1,
	AcceptNewLegalEntityRequestV1,
	AcceptNewLegalEntityResponseV1,
	AccessDenied,
	ActiveSubscriptionResponseV1,
	AdvanceCandidateInterviewV1,
	AlgoCoursePlanGroupV1,
	AnonymousRegisterForFreeCourse400ResponseV1,
	AnonymousRegisterForFreeCourseResponseV1,
	AnonymousRegisterForFreeCourseV1,
	AnonymousRegisterForWebinarRequestV1,
	AssignCRMClientManagerRequestV1,
	CRMActivityStatusV1,
	CRMAutomationEventStatusV1,
	CRMAutomationEventsResponseV1,
	CRMAutomationNotRetryableResponseV1,
	CRMClientDetailsResponseV1,
	CRMClientGradeV1,
	CRMClientInterestTopicsResponseV1,
	CRMClientLeadScoringResponseV1,
	CRMClientListResponseV1,
	CRMClientManagerRequiredResponseV1,
	CRMClientNotFoundResponseV1,
	CRMClientOccupationV1,
	CRMClientSortV1,
	CRMClientSubmissionsResponseV1,
	CRMCustomerStatusV1,
	CRMDialogStatusV1,
	CRMEntrySourceV1,
	CRMInterestTopicsResponseV1,
	CRMInvalidManagerResponseV1,
	CRMManagerListResponseV1,
	CRMManagerTaskV1,
	CRMManagerTasksResponseV1,
	CRMPrimaryLanguageV1,
	CRMProgressReportConflictResponseV1,
	CRMProgressReportGenerationResponseV1,
	CRMResumeDownloadNotFoundResponseV1,
	CRMResumeV1,
	CRMRiskStatusV1,
	CRMSortOrderV1,
	CRMStageV1,
	CRMStagesResponseV1,
	CRMSubmissionV1,
	CRMTaskStatusV1,
	CRMTaskTypeV1,
	CRMValidationFailedResponseV1,
	CandidateInterviewAttemptV1,
	CandidateInterviewAuthoringCreateV1,
	CandidateInterviewAuthoringDefinitionV1,
	CandidateInterviewAuthoringListV1,
	CandidateInterviewAuthoringUpdateV1,
	CandidateInterviewHistoryV1,
	CandidateInterviewItemReplayV1,
	CandidateInterviewReportConfigEnvelopeV1,
	CandidateInterviewReportConfigUpdateV1,
	CandidateInterviewReportEnvelopeV1,
	CandidateInterviewV1,
	CandidateSelectionErrorV1,
	CandidateSelectionStatusV1,
	CheckAccessForKinescopeVideoRequestV1,
	CodeLanguagesV1,
	CommerceAccessV1,
	CommerceBalanceV1,
	CommerceCatalogV1,
	CommerceOfferV1,
	CompleteAITask400ResponseV1,
	ConfirmTelegramLink400ResponseV1,
	ConfirmTelegramLinkRequestV1,
	ConnectTelegram400ErrorResponseV1,
	ConnectTelegramRequestV1,
	ConnectTelegramWithBotResponseV1,
	ContentBlockUnknownV1,
	ContentSearchResponseV1,
	ContentSearchTypeV1,
	CourseLeadMagnetV1,
	CourseTheoryIDV1,
	CoursesV1,
	CreateAIDialog400ErrorResponseV1,
	CreateAIDialogResponseV1,
	CreateAIDialogV1,
	CreateAdminAIAlgoProblem409ResponseV1,
	CreateAdminAIAlgoProblemRequestV1,
	CreateAdminAIProblem400ResponseV1,
	CreateAdminAIProblemRequestV1,
	CreateAdminAIProblemResponseV1,
	CreateAuthTokenResponseV1,
	CreateAuthTokenV1,
	CreateCRMClientActivityRequestV1,
	CreateCRMManagerTaskRequestV1,
	CreateCourseRequestV1,
	CreateCourseResponseV1,
	CreateEmailVerificationCode400ErrorResponse,
	CreateEmailVerificationCode403ErrorResponse,
	CreateEmailVerificationCode404ErrorResponse,
	CreateEmailVerificationCodeRequestV1,
	CreateEmailVerificationCodeResponseV1,
	CreateLessonRequestV1,
	CreateLessonResponseV1,
	CreatePasswordRestoreCodeRequestV1,
	CreatePasswordRestoreCodeResponseV1,
	CreatePayment400ResponseV1,
	CreateProblemRequestV1,
	CreateProblemResponseV1,
	CreateProblemWithAI200ResponseV1,
	CreateProblemWithAI400ResponseV1,
	CreateProblemWithAIRequestV1,
	CreateRoadMapRequestV1,
	CreateRoadMapResponseV1,
	CreateSurveyRequestV1,
	CreateSystemNotificationRequestV1,
	CreateTheoryLessonRequestV1,
	CreateTheoryPassResponseV1,
	CreateTheoryRequestV1,
	CreateUserAIProblemFeedbackRequestV1,
	CreateUserFeedbackRequestV1,
	CreateUserInterview400ErrorResponse,
	CreateUserInterviewResponseV1,
	CreateUserRequestV1,
	CreateUserResponseV1,
	DeleteUserProgressResponseV1,
	FeedbackContextUnavailableV1,
	FeedbackListResponseV1,
	FeedbackNotFoundV1,
	FeedbackTargetEnumV1,
	FreeInterview400Response,
	FreeInterview409Response,
	FreeInterview503Response,
	FreeInterviewCompletionOffersV1,
	FreeInterviewLandingV1,
	FreeInterviewOnboardingV1,
	FreeInterviewStartV1,
	FreeInterviewStateV1,
	GenerateSubmissionAiReportV1,
	GetAIAlgoExecutionFilesResponseV1,
	GetAIAlgoProblemContentResponseV1,
	GetAIAlgoSandboxResponseV1,
	GetAIDialogMessagesResponseV1,
	GetAIDialogResponseV1,
	GetAIProblemResponseV1,
	GetAdminAIProblemResponseV1,
	GetAllUserInterviewsResponseV1,
	GetCreateProblemWithAIStatusResponseV1,
	GetInterviewSimulatorResponseV1,
	GetListProblemFilesResponseV1,
	GetPromoCodeResponseV1,
	GetUserInterviewResponseV1,
	GrantPremiumDetailedErrorResponseV1,
	GrantPremiumForUserV1,
	ImportCourseRequestV1,
	ImportCourseResponseV1,
	ImportLessonRequestV1,
	ImportLessonResponseV1,
	ImportProblemRequestV1,
	ImportProblemResponseV1,
	InitProductPaymentV1,
	InternalAIAlgoCardUpdateRequestV1,
	InternalAIAlgoCardUpdateResultV1,
	InternalAIAlgoCardV1,
	InternalAIAlgoTemplateSnapshotV1,
	InternalAIAlgoTemplateUpdateRequestV1,
	InternalAIAlgoTemplateUpdateResultV1,
	InternalAIAlgoTestsSnapshotV1,
	InternalAIAlgoTestsUpdateRequestV1,
	InternalAIAlgoTestsUpdateResultV1,
	InternalAIDialogResultV1,
	InternalAIInterviewListResponseV1,
	InternalAIProblemAuthoringGuideV1,
	InternalAIProblemBatchCreateEnvelopeV1,
	InternalAIProblemBatchCreateResultV1,
	InternalAIProblemCreateEnvelopeV1,
	InternalAIProblemCreateResultV1,
	InternalAIProblemPatchResultV1,
	InternalAIProblemPatchV1,
	InternalCandidateInterviewResultV1,
	InternalCompanyConflictResponseV1,
	InternalCompanyCreateRequestV1,
	InternalCompanyListResponseV1,
	InternalCompanyPatchRequestV1,
	InternalCompanyV1,
	InternalCourseCreateRequestV1,
	InternalCourseErrorV1,
	InternalCourseListResponseV1,
	InternalCourseUpdateRequestV1,
	InternalCourseUpdateResultV1,
	InternalCourseV1,
	InternalErrorV1,
	InternalFeedbackDialogV1,
	InternalFeedbackListV1,
	InternalFeedbackResolveV1,
	InternalProblemAuthoringErrorV1,
	InternalProblemCompaniesResponseV1,
	InternalProblemDetailV1,
	InternalProblemListResponseV1,
	InternalProblemPatchRequestV1,
	InternalProblemSolutionsCheckRequestV1,
	InternalProblemSolutionsCheckResultV1,
	InternalProblemTemplateUpdateRequestV1,
	InternalProblemTemplateUpdateResultV1,
	InternalProblemTestsSnapshotV1,
	InternalProblemTestsUpdateRequestV1,
	InternalProblemTestsUpdateResultV1,
	InternalProblemUpdateRequestV1,
	InternalProblemWriteResultV1,
	InternalRoadmapCreateRequestV1,
	InternalRoadmapErrorV1,
	InternalRoadmapListResponseV1,
	InternalRoadmapUpdateRequestV1,
	InternalRoadmapUpdateResultV1,
	InternalRoadmapV1,
	InternalVerifyCredentialsRequestV1,
	InternalVerifyCredentialsResponseV1,
	InvalidFeedbackInputV1,
	LastSubmissionAiReportV1,
	LeadMagnetClassifyInputV1,
	LeadMagnetClassifyResultV1,
	LeadMagnetErrorV1,
	LeadScoreEventLog,
	LessonListResponseV1,
	LinkTelegramCredentials409ResponseV1,
	LinkTelegramCredentialsRequestV1,
	ListAIAlgoSubmissionsResponseV1,
	ListAIDialogsResponseV1,
	LoginByToken403ErrorResponse,
	LoginByToken404ErrorResponse,
	LoginByTokenRequestV1,
	NotAuthorized,
	OkResponse,
	OrderNotCancellable,
	PaymentHistoryResponseV1,
	PaymentUrlSuccessV1,
	PermissionLevelV1,
	PostCompleteAISelectTaskV1,
	PostCreateUserInterviewV1,
	PostProblemAlgorithmsTemplatesRequestV1,
	PostProblemClassAlgorithmsTemplatesRequestV1,
	PostSendAIDialogMessageV1,
	PostSubmitAICodeReviewTaskV1,
	PostSubmitAIProblemCodeTaskV1,
	ProblemCategoryEnum,
	ProblemClassAlgorithmsCodeGenStateResponseV1,
	ProblemCodeGenStateResponseV1,
	ProblemListV1,
	ProblemResourceV1,
	ProblemTagCreateV1,
	ProblemTagErrorV1,
	ProblemTagListV1,
	ProblemTagTypeCreateV1,
	ProblemTagTypeListV1,
	ProblemTagTypeUpdateV1,
	ProblemTagTypeV1,
	ProblemTagUpdateV1,
	ProblemTagV1,
	ProblemTestsV1,
	ProblemV1,
	ProblemVideoExplanationV1,
	ProductTariffPaymentInfoResponseV1,
	ProductTariffsResponseV1,
	PromoRegistrationBeginV1,
	PromoRegistrationChallengeV1,
	PromoRegistrationConfirmV1,
	PromoRegistrationErrorV1,
	ProviderId,
	PublicFreeInterviewLandingV1,
	RegisterForFreeCourseResponseV1,
	RegisterForFreeCourseV1,
	RegisterForWebinarRequestV1,
	ReplaceCRMClientInterestTopicsRequestV1,
	ResourceNotFound,
	ResourceNotFound404ResponseV1,
	RoadMapV1,
	SalebotErrorResponse,
	SalebotLinkStateV1,
	SandboxCodeV1,
	SecretSQL400Response,
	SecretSQLRequestV1,
	SecretSQLResponseV1,
	SelectionTagListV1,
	SelectionTagV1,
	SolutionPromptV1,
	SolvedTask,
	StartCandidateInterviewV1,
	StaticLessonV1,
	SubmissionResponseV1,
	SubmitAIAlgoCodeRequestV1,
	SubmitAICode400ErrorResponseV1,
	SubmitRequestV1,
	SubmitResponseV1,
	SubmitSurveyResponseRequestV1,
	SubscriptionChangedResponseV1,
	SubscriptionPaymentInfoResponseV1,
	SubscriptionsResponseV1,
	SuccessCancellingPaymentV1,
	SuccessDisablingRecurrentV1,
	SuccessPaymentV1,
	SurveyAnswerInvalidResponseV1,
	SurveyDistributionV1,
	SurveyExistsResponseV1,
	SurveyLockedResponseV1,
	SurveyNotFoundResponseV1,
	SurveyResponseExistsResponseV1,
	SurveySchemaInvalidResponseV1,
	SurveyV1,
	SystemNotification400ErrorResponseV1,
	SystemNotificationsAdminListV1,
	SystemNotificationsListV1,
	TelegramAuth,
	TelegramAuth400ErrorResponse,
	TelegramUserRulesV1,
	TelegramUserV1,
	TheoryLessonIdV1,
	TheoryTestRequestV1,
	TheoryTestSubmissionResponseV1,
	TheoryTestsAnswerV1,
	TheoryTestsUserSubmissionsV1,
	TheoryV1,
	UnsubscribeFromMailingRequestV1,
	UnsubscribeFromMailingResponseV1,
	UpdateAIAlgoSandboxRequestV1,
	UpdateAIDialogStatus400Response,
	UpdateAIDialogStatusRequestV1,
	UpdateAdminAIAlgoContent400ResponseV1,
	UpdateAdminAIAlgoContent422ResponseV1,
	UpdateAdminAIAlgoContentRequestV1,
	UpdateAdminAIProblem400ResponseV1,
	UpdateAdminAIProblemRequestV1,
	UpdateAdminUser400Response,
	UpdateAdminUserRequestV1,
	UpdateCRMClientRequestV1,
	UpdateCRMManagerTaskRequestV1,
	UpdateCRMManagerTaskStatusRequestV1,
	UpdateCourse400ErrorResponse,
	UpdateCoursePlan400Response,
	UpdateCourseV1,
	UpdateLessonRequestV1,
	UpdateProblemRequestV1,
	UpdateProblemResponse422ErrorV1,
	UpdateRoadMapRequestV1,
	UpdateSelfPrimaryLanguage400ResponseV1,
	UpdateSelfPrimaryLanguageRequestV1,
	UpdateSurveyRequestV1,
	UpdateSystemNotification409ErrorResponseV1,
	UpdateSystemNotificationRequestV1,
	UpdateTheoryRequestV1,
	UpdateUserPassword400ErrorResponse,
	UpdateUserPassword403ErrorResponse,
	UpdateUserPasswordRequestV1,
	UpdateUserPasswordResponseV1,
	UserActivityDailyResponseV1,
	UserActivityResponseV1,
	UserActivitySubmissionResultFilterEnum,
	UserActivityTypeFilterEnum,
	UserActivityValidationFailedResponseV1,
	UserAlreadyHasPremiumError,
	UserLoginErrorResponse,
	UserPaymentHistoryResponseV1,
	UserRegistration400ErrorResponse,
	UserRegistration403ErrorResponse,
	UserRegistration404ErrorResponse,
	UserSearchListV1,
	UserSubscriptionAuditListV1,
	UserSurveyResponseV1,
	UserSurveysV1,
	UserV1,
	ValidatePromoCode400ResponseV1,
	VerifySuccessPaymentErrorResponse,
	WebinarRegistrationResponseV1,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class V1<
	SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
	/**
	 * @description Service-account endpoint for the frontend server. Answers are limited to 512 Unicode code points. A request UUID is idempotent. Model and payer are selected by the server.
	 *
	 * @name ClassifyLeadMagnetInternalV1
	 * @summary Classify a lead magnet answer
	 * @request POST:/v1/internal/lead-magnets/classify
	 */
	classifyLeadMagnetInternalV1 = (
		data: LeadMagnetClassifyInputV1,
		params: RequestParams = {},
	) =>
		this.request<
			LeadMagnetClassifyResultV1,
			| LeadMagnetErrorV1
			| {
					message: string;
			  }
		>({
			path: `/v1/internal/lead-magnets/classify`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name BeginInterviewPromoRegistrationV1
	 * @summary Отправить код регистрации или предложить вход по паролю
	 * @request POST:/v1/interview-promo/register
	 */
	beginInterviewPromoRegistrationV1 = (
		data: PromoRegistrationBeginV1,
		params: RequestParams = {},
	) =>
		this.request<PromoRegistrationChallengeV1, PromoRegistrationErrorV1>({
			path: `/v1/interview-promo/register`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name ConfirmInterviewPromoRegistrationV1
	 * @summary Подтвердить новый email и установить cookies авторизации
	 * @request POST:/v1/interview-promo/register/confirm
	 */
	confirmInterviewPromoRegistrationV1 = (
		data: PromoRegistrationConfirmV1,
		params: RequestParams = {},
	) =>
		this.request<void, PromoRegistrationErrorV1>({
			path: `/v1/interview-promo/register/confirm`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @name GetPublicCourseLeadMagnetV1
	 * @summary Диалог регистрации с вариантами курсов
	 * @request GET:/v1/course-lead-magnets/{leadMagnetId}
	 */
	getPublicCourseLeadMagnetV1 = (
		leadMagnetId: string,
		params: RequestParams = {},
	) =>
		this.request<CourseLeadMagnetV1, void>({
			path: `/v1/course-lead-magnets/${leadMagnetId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name GetPublicFreeInterviewLandingV1
	 * @summary Публичное описание опубликованного лендинга бесплатного интервью
	 * @request GET:/v1/free-interview-landings/{courseId}
	 */
	getPublicFreeInterviewLandingV1 = (
		courseId: string,
		params: RequestParams = {},
	) =>
		this.request<PublicFreeInterviewLandingV1, void>({
			path: `/v1/free-interview-landings/${courseId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name GetFreeInterviewLandingV1
	 * @request GET:/v1/self/free-interview-landings/{courseId}
	 */
	getFreeInterviewLandingV1 = (courseId: string, params: RequestParams = {}) =>
		this.request<
			FreeInterviewLandingV1,
			| FreeInterview400Response
			| void
			| FreeInterview409Response
			| FreeInterview503Response
		>({
			path: `/v1/self/free-interview-landings/${courseId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name GetFreeInterviewStateV1
	 * @request GET:/v1/self/free-interviews/{interviewId}
	 */
	getFreeInterviewStateV1 = (
		interviewId: string,
		query?: {
			courseId?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			FreeInterviewStateV1,
			| FreeInterview400Response
			| void
			| FreeInterview409Response
			| FreeInterview503Response
		>({
			path: `/v1/self/free-interviews/${interviewId}`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name GetFreeInterviewCompletionOffersV1
	 * @summary Тарифы финальной страницы курса из сохранённого бесплатного прохождения
	 * @request GET:/v1/self/free-interviews/{interviewId}/completion-offers
	 */
	getFreeInterviewCompletionOffersV1 = (
		interviewId: string,
		params: RequestParams = {},
	) =>
		this.request<
			FreeInterviewCompletionOffersV1,
			void | FreeInterview409Response
		>({
			path: `/v1/self/free-interviews/${interviewId}/completion-offers`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name SaveFreeInterviewOnboardingV1
	 * @request PUT:/v1/self/free-interviews/{interviewId}/onboarding
	 */
	saveFreeInterviewOnboardingV1 = (
		interviewId: string,
		data: FreeInterviewOnboardingV1,
		params: RequestParams = {},
	) =>
		this.request<
			FreeInterviewStateV1,
			| FreeInterview400Response
			| void
			| FreeInterview409Response
			| FreeInterview503Response
		>({
			path: `/v1/self/free-interviews/${interviewId}/onboarding`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name PrepareFreeInterviewSalebotLinkV1
	 * @request POST:/v1/self/free-interviews/{interviewId}/salebot-link
	 */
	prepareFreeInterviewSalebotLinkV1 = (
		interviewId: string,
		data: {
			courseId: string;
			/** @default false */
			createLink?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<SalebotLinkStateV1, SalebotErrorResponse>({
			path: `/v1/self/free-interviews/${interviewId}/salebot-link`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name ConfirmSalebotTelegramLinkV1
	 * @request POST:/v1/integrations/salebot/telegram-link
	 */
	confirmSalebotTelegramLinkV1 = (
		data: {
			/** @maxLength 64 */
			token: string;
			/** @format int64 */
			projectId: number;
			/** @format int64 */
			clientId: number;
			/** @format int64 */
			telegramId: number;
		},
		params: RequestParams = {},
	) =>
		this.request<void, SalebotErrorResponse>({
			path: `/v1/integrations/salebot/telegram-link`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @name StartFreeInterviewV1
	 * @request POST:/v1/self/free-interviews/{interviewId}/start
	 */
	startFreeInterviewV1 = (
		interviewId: string,
		data: FreeInterviewStartV1,
		params: RequestParams = {},
	) =>
		this.request<
			CandidateInterviewAttemptV1,
			| FreeInterview400Response
			| void
			| FreeInterview409Response
			| FreeInterview503Response
		>({
			path: `/v1/self/free-interviews/${interviewId}/start`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name DeliverCandidateInterviewReportV1
	 * @request POST:/v1/candidate-interview-attempts/{id}/report/delivery
	 */
	deliverCandidateInterviewReportV1 = (
		id: string,
		params: RequestParams = {},
	) =>
		this.request<CandidateInterviewReportEnvelopeV1, void>({
			path: `/v1/candidate-interview-attempts/${id}/report/delivery`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name GetCandidateInterviewSelectionV1
	 * @request GET:/v1/candidate-interview-selections/{id}
	 */
	getCandidateInterviewSelectionV1 = (id: string, params: RequestParams = {}) =>
		this.request<CandidateSelectionStatusV1, InternalErrorV1>({
			path: `/v1/candidate-interview-selections/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name ListSelectionTagsInternalV1
	 * @request GET:/v1/internal/content/selection-tags
	 */
	listSelectionTagsInternalV1 = (params: RequestParams = {}) =>
		this.request<SelectionTagListV1, InternalErrorV1>({
			path: `/v1/internal/content/selection-tags`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name UpsertSelectionTagInternalV1
	 * @request PUT:/v1/internal/content/selection-tags
	 */
	upsertSelectionTagInternalV1 = (
		data: SelectionTagV1,
		params: RequestParams = {},
	) =>
		this.request<SelectionTagV1, InternalErrorV1>({
			path: `/v1/internal/content/selection-tags`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name GetAiProblemSelectionTagsInternalV1
	 * @request GET:/v1/internal/content/ai-problems/{id}/selection-tags
	 */
	getAiProblemSelectionTagsInternalV1 = (
		id: string,
		params: RequestParams = {},
	) =>
		this.request<AIProblemSelectionTagsV1, InternalErrorV1>({
			path: `/v1/internal/content/ai-problems/${id}/selection-tags`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name UpdateAiProblemSelectionTagsInternalV1
	 * @request PUT:/v1/internal/content/ai-problems/{id}/selection-tags
	 */
	updateAiProblemSelectionTagsInternalV1 = (
		id: string,
		data: AIProblemSelectionTagsUpdateV1,
		params: RequestParams = {},
	) =>
		this.request<AIProblemSelectionTagsV1, InternalErrorV1>({
			path: `/v1/internal/content/ai-problems/${id}/selection-tags`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags payment
	 * @name GetCourseOffersV1
	 * @request GET:/v1/course-offers
	 */
	getCourseOffersV1 = (
		query?: {
			courseId?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CommerceCatalogV1, any>({
			path: `/v1/course-offers`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags payment
	 * @name GetCourseOfferV1
	 * @request GET:/v1/course-offers/{offerId}
	 */
	getCourseOfferV1 = (offerId: string, params: RequestParams = {}) =>
		this.request<CommerceOfferV1, any>({
			path: `/v1/course-offers/${offerId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags payment
	 * @name GetCreditTopupOffersV1
	 * @request GET:/v1/credit-topup-offers
	 */
	getCreditTopupOffersV1 = (params: RequestParams = {}) =>
		this.request<CommerceCatalogV1, any>({
			path: `/v1/credit-topup-offers`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags payment
	 * @name GetSelfCourseAccessV1
	 * @request GET:/v1/self/course-access
	 */
	getSelfCourseAccessV1 = (params: RequestParams = {}) =>
		this.request<CommerceAccessV1, any>({
			path: `/v1/self/course-access`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags payment
	 * @name GetSelfAiBalanceV1
	 * @request GET:/v1/self/ai-balance
	 */
	getSelfAiBalanceV1 = (params: RequestParams = {}) =>
		this.request<CommerceBalanceV1, any>({
			path: `/v1/self/ai-balance`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags payment
	 * @name CronCommerceCreditsV1
	 * @request POST:/v1/internal/cron/commerce-credits
	 */
	cronCommerceCreditsV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/commerce-credits`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name ListCandidateInterviewsInternalV1
	 * @request GET:/v1/internal/content/candidate-interviews
	 */
	listCandidateInterviewsInternalV1 = (
		query: {
			/** @maxLength 255 */
			query?: string;
			type?: 'welcome' | 'regular';
			is_visible?: boolean;
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<CandidateInterviewAuthoringListV1, InternalErrorV1>({
			path: `/v1/internal/content/candidate-interviews`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name CreateCandidateInterviewInternalV1
	 * @request POST:/v1/internal/content/candidate-interviews
	 */
	createCandidateInterviewInternalV1 = (
		data: CandidateInterviewAuthoringCreateV1,
		params: RequestParams = {},
	) =>
		this.request<CandidateInterviewAuthoringDefinitionV1, InternalErrorV1>({
			path: `/v1/internal/content/candidate-interviews`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name GetCandidateInterviewInternalV1
	 * @request GET:/v1/internal/content/candidate-interviews/{id}
	 */
	getCandidateInterviewInternalV1 = (id: string, params: RequestParams = {}) =>
		this.request<CandidateInterviewAuthoringDefinitionV1, InternalErrorV1>({
			path: `/v1/internal/content/candidate-interviews/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name UpdateCandidateInterviewInternalV1
	 * @request PATCH:/v1/internal/content/candidate-interviews/{id}
	 */
	updateCandidateInterviewInternalV1 = (
		id: string,
		data: CandidateInterviewAuthoringUpdateV1,
		params: RequestParams = {},
	) =>
		this.request<CandidateInterviewAuthoringDefinitionV1, InternalErrorV1>({
			path: `/v1/internal/content/candidate-interviews/${id}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name GetCandidateInterviewReportV1
	 * @request GET:/v1/candidate-interview-attempts/{id}/report
	 */
	getCandidateInterviewReportV1 = (id: string, params: RequestParams = {}) =>
		this.request<CandidateInterviewReportEnvelopeV1, InternalErrorV1>({
			path: `/v1/candidate-interview-attempts/${id}/report`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name GetCandidateInterviewItemV1
	 * @request GET:/v1/candidate-interview-attempts/{id}/items/{position}
	 */
	getCandidateInterviewItemV1 = (
		id: string,
		position: number,
		params: RequestParams = {},
	) =>
		this.request<CandidateInterviewItemReplayV1, InternalErrorV1>({
			path: `/v1/candidate-interview-attempts/${id}/items/${position}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name GetCandidateInterviewReportConfigInternalV1
	 * @request GET:/v1/internal/content/candidate-interviews/{id}/report-config
	 */
	getCandidateInterviewReportConfigInternalV1 = (
		id: string,
		params: RequestParams = {},
	) =>
		this.request<
			CandidateInterviewReportConfigEnvelopeV1,
			InternalErrorV1 | InternalRoadmapErrorV1
		>({
			path: `/v1/internal/content/candidate-interviews/${id}/report-config`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name UpdateCandidateInterviewReportConfigInternalV1
	 * @request PATCH:/v1/internal/content/candidate-interviews/{id}/report-config
	 */
	updateCandidateInterviewReportConfigInternalV1 = (
		id: string,
		data: CandidateInterviewReportConfigUpdateV1,
		params: RequestParams = {},
	) =>
		this.request<
			CandidateInterviewReportConfigEnvelopeV1,
			InternalErrorV1 | InternalRoadmapErrorV1
		>({
			path: `/v1/internal/content/candidate-interviews/${id}/report-config`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name RegenerateCandidateInterviewReportInternalV1
	 * @request POST:/v1/internal/content/candidate-interview-attempts/{id}/report/regenerate
	 */
	regenerateCandidateInterviewReportInternalV1 = (
		id: string,
		params: RequestParams = {},
	) =>
		this.request<
			CandidateInterviewReportEnvelopeV1,
			InternalErrorV1 | InternalRoadmapErrorV1
		>({
			path: `/v1/internal/content/candidate-interview-attempts/${id}/report/regenerate`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name GetCandidateInterviewV1
	 * @request GET:/v1/candidate-interviews/{id}
	 */
	getCandidateInterviewV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			CandidateInterviewV1,
			{
				message: string;
			}
		>({
			path: `/v1/candidate-interviews/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name ListCandidateInterviewAttemptsV1
	 * @request GET:/v1/candidate-interviews/{id}/attempts
	 */
	listCandidateInterviewAttemptsV1 = (
		id: string,
		query: {
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<CandidateInterviewHistoryV1, InternalErrorV1>({
			path: `/v1/candidate-interviews/${id}/attempts`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name StartCandidateInterviewV1
	 * @request POST:/v1/candidate-interviews/{id}/attempts
	 */
	startCandidateInterviewV1 = (
		id: string,
		data: StartCandidateInterviewV1,
		params: RequestParams = {},
	) =>
		this.request<
			CandidateInterviewAttemptV1,
			| {
					message: string;
			  }
			| CandidateSelectionErrorV1
		>({
			path: `/v1/candidate-interviews/${id}/attempts`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name GetCandidateInterviewAttemptV1
	 * @request GET:/v1/candidate-interview-attempts/{id}
	 */
	getCandidateInterviewAttemptV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			CandidateInterviewAttemptV1,
			{
				message: string;
			}
		>({
			path: `/v1/candidate-interview-attempts/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name AdvanceCandidateInterviewV1
	 * @request POST:/v1/candidate-interview-attempts/{id}/advance
	 */
	advanceCandidateInterviewV1 = (
		id: string,
		data: AdvanceCandidateInterviewV1,
		params: RequestParams = {},
	) =>
		this.request<
			CandidateInterviewAttemptV1,
			{
				message: string;
			}
		>({
			path: `/v1/candidate-interview-attempts/${id}/advance`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name FinishCandidateInterviewV1
	 * @request POST:/v1/candidate-interview-attempts/{id}/finish
	 */
	finishCandidateInterviewV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			CandidateInterviewAttemptV1,
			{
				message: string;
			}
		>({
			path: `/v1/candidate-interview-attempts/${id}/finish`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags candidate-interview
	 * @name CronCandidateInterviewTimeoutsV1
	 * @request POST:/v1/internal/cron/candidate-interviews/expire
	 */
	cronCandidateInterviewTimeoutsV1 = (params: RequestParams = {}) =>
		this.request<
			void,
			{
				message: string;
			}
		>({
			path: `/v1/internal/cron/candidate-interviews/expire`,
			method: 'POST',
			...params,
		});
	/**
	 * @description Liveness
	 *
	 * @tags system
	 * @name Liveness
	 * @request GET:/v1/system/liveness
	 */
	liveness = (params: RequestParams = {}) =>
		this.request<void, any>({
			path: `/v1/system/liveness`,
			method: 'GET',
			...params,
		});
	/**
	 * @description Readiness
	 *
	 * @tags system
	 * @name Readiness
	 * @request GET:/v1/system/readiness
	 */
	readiness = (params: RequestParams = {}) =>
		this.request<void, any>({
			path: `/v1/system/readiness`,
			method: 'GET',
			...params,
		});
	/**
	 * @description Сохранить информацию о пользователе телеграмм. Если пользователь уже создан, то обновит информацию по нему
	 *
	 * @tags telegram-integration
	 * @name CreateTelegramAccountV1
	 * @request POST:/v1/telegram-integration/account
	 */
	createTelegramAccountV1 = (
		data: TelegramUserV1,
		params: RequestParams = {},
	) =>
		this.request<
			{
				/** @format uuid */
				token: string;
			},
			NotAuthorized | AccessDenied
		>({
			path: `/v1/telegram-integration/account`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Связать пользователя телеграмм с профилем algocode
	 *
	 * @tags telegram-integration
	 * @name LinkTelegramAccountV1
	 * @request POST:/v1/telegram-integration/users
	 */
	linkTelegramAccountV1 = (data: TelegramAuth, params: RequestParams = {}) =>
		this.request<
			ContentBlockUnknownV1,
			TelegramAuth400ErrorResponse | NotAuthorized | AccessDenied
		>({
			path: `/v1/telegram-integration/users`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения информации о пользователе по telegram_user_id
	 *
	 * @tags users
	 * @name GetTelegramUserRulesV1
	 * @request GET:/v1/telegram-integration/users/{userID}
	 */
	getTelegramUserRulesV1 = (userId: number, params: RequestParams = {}) =>
		this.request<TelegramUserRulesV1, NotAuthorized | ResourceNotFound>({
			path: `/v1/telegram-integration/users/${userId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Подтверждение привязки Telegram-аккаунта по deep-link токену. Вызывается сервис-аккаунтом бота после нажатия пользователем /start.
	 *
	 * @tags telegram-integration
	 * @name ConfirmTelegramLinkV1
	 * @request POST:/v1/telegram-integration/link/confirm
	 */
	confirmTelegramLinkV1 = (
		data: ConfirmTelegramLinkRequestV1,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, ConfirmTelegramLink400ResponseV1 | NotAuthorized>({
			path: `/v1/telegram-integration/link/confirm`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Привязка Telegram-аккаунта по логину и паролю пользователя algocode.io. Вызывается сервис-аккаунтом бота после команды /join. Пароль конечного пользователя передаётся в теле (по HTTPS) и не логируется.
	 *
	 * @tags telegram-integration
	 * @name LinkTelegramCredentialsV1
	 * @request POST:/v1/telegram-integration/link/credentials
	 */
	linkTelegramCredentialsV1 = (
		data: LinkTelegramCredentialsRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			NotAuthorized | LinkTelegramCredentials409ResponseV1
		>({
			path: `/v1/telegram-integration/link/credentials`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Отправка аналитических событий
	 *
	 * @tags analytics
	 * @name CreateLeadScoringEventsV1
	 * @request POST:/v1/analytics/scoring
	 */
	createLeadScoringEventsV1 = (
		data: LeadScoreEventLog,
		params: RequestParams = {},
	) =>
		this.request<
			ContentBlockUnknownV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/analytics/scoring`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения информации о текущем пользователе
	 *
	 * @tags users
	 * @name GetSelfProfileV1
	 * @request GET:/v1/self
	 */
	getSelfProfileV1 = (params: RequestParams = {}) =>
		this.request<UserV1, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/self`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения пользовательской истории оплаты (deprecated)
	 *
	 * @tags users
	 * @name GetPaymentHistoryV1
	 * @request GET:/v1/self/payments
	 */
	getPaymentHistoryV1 = (
		query: {
			/** @min 0 */
			skip: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<PaymentHistoryResponseV1, NotAuthorized>({
			path: `/v1/self/payments`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения пользовательской истории оплаты
	 *
	 * @tags users
	 * @name GetUserPaymentHistoryV1
	 * @request GET:/v1/self/payment-history
	 */
	getUserPaymentHistoryV1 = (
		query: {
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<UserPaymentHistoryResponseV1, NotAuthorized>({
			path: `/v1/self/payment-history`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения рекуррентных данных для всех продуктов
	 *
	 * @tags users
	 * @name GetUserActiveSubscriptionsV1
	 * @request GET:/v1/self/subscriptions
	 */
	getUserActiveSubscriptionsV1 = (params: RequestParams = {}) =>
		this.request<ActiveSubscriptionResponseV1[], NotAuthorized>({
			path: `/v1/self/subscriptions`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для отключения рекуррентных списаний
	 *
	 * @tags users
	 * @name PutDisableRecurrentForSubscription
	 * @request PUT:/v1/self/subscriptions/{subscriptionID}/disable
	 */
	putDisableRecurrentForSubscription = (
		subscriptionId: string,
		params: RequestParams = {},
	) =>
		this.request<
			SuccessDisablingRecurrentV1,
			NotAuthorized | SubscriptionChangedResponseV1
		>({
			path: `/v1/self/subscriptions/${subscriptionId}/disable`,
			method: 'PUT',
			format: 'json',
			...params,
		});
	/**
	 * @description API для подтверждения согласия с новым юридическим лицом
	 *
	 * @tags users
	 * @name PostAcceptNewLegalEntityV1
	 * @request POST:/v1/self/accept-legal-entity
	 */
	postAcceptNewLegalEntityV1 = (
		data: AcceptNewLegalEntityRequestV1,
		params: RequestParams = {},
	) =>
		this.request<AcceptNewLegalEntityResponseV1, NotAuthorized>({
			path: `/v1/self/accept-legal-entity`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для установки основного языка программирования пользователя
	 *
	 * @tags users
	 * @name PutSelfPrimaryLanguageV1
	 * @request PUT:/v1/self/primary-language
	 */
	putSelfPrimaryLanguageV1 = (
		data: UpdateSelfPrimaryLanguageRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			UserV1,
			| UpdateSelfPrimaryLanguage400ResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
		>({
			path: `/v1/self/primary-language`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для регистрации
	 *
	 * @tags accounts
	 * @name PostUserCreationV1
	 * @request POST:/v1/accounts/register
	 */
	postUserCreationV1 = (
		data: CreateUserRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			CreateUserResponseV1,
			| UserRegistration400ErrorResponse
			| UserRegistration403ErrorResponse
			| UserRegistration404ErrorResponse
		>({
			path: `/v1/accounts/register`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания и отправки OTP кода на почту
	 *
	 * @tags accounts
	 * @name PostCreationOfEmailVerificationCodeV1
	 * @request POST:/v1/accounts/register/email
	 */
	postCreationOfEmailVerificationCodeV1 = (
		data: CreateEmailVerificationCodeRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			CreateEmailVerificationCodeResponseV1,
			| CreateEmailVerificationCode400ErrorResponse
			| CreateEmailVerificationCode403ErrorResponse
			| CreateEmailVerificationCode404ErrorResponse
		>({
			path: `/v1/accounts/register/email`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания token из credentials
	 *
	 * @tags accounts
	 * @name PostCreationOfAuthTokenV1
	 * @request POST:/v1/accounts/login
	 */
	postCreationOfAuthTokenV1 = (
		data: CreateAuthTokenV1,
		params: RequestParams = {},
	) =>
		this.request<CreateAuthTokenResponseV1, UserLoginErrorResponse>({
			path: `/v1/accounts/login`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления пароля с OTP кодом
	 *
	 * @tags accounts
	 * @name PostUpdatedUserPasswordV1
	 * @request POST:/v1/accounts/restore
	 */
	postUpdatedUserPasswordV1 = (
		data: UpdateUserPasswordRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			UpdateUserPasswordResponseV1,
			| UpdateUserPassword400ErrorResponse
			| UpdateUserPassword403ErrorResponse
			| ResourceNotFound
		>({
			path: `/v1/accounts/restore`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания token и отправки на почту при обновлении пароля
	 *
	 * @tags accounts
	 * @name PostCreationOfUpdatedPasswordCodeV1
	 * @request POST:/v1/accounts/restore/code
	 */
	postCreationOfUpdatedPasswordCodeV1 = (
		data: CreatePasswordRestoreCodeRequestV1,
		params: RequestParams = {},
	) =>
		this.request<CreatePasswordRestoreCodeResponseV1, ResourceNotFound>({
			path: `/v1/accounts/restore/code`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления access/refresh пары
	 *
	 * @tags accounts
	 * @name CreateAccessAndRefreshTokenV1
	 * @request POST:/v1/accounts/refreshtoken
	 */
	createAccessAndRefreshTokenV1 = (params: RequestParams = {}) =>
		this.request<void, NotAuthorized | ResourceNotFound>({
			path: `/v1/accounts/refreshtoken`,
			method: 'POST',
			...params,
		});
	/**
	 * @description API для обновления access/refresh пары
	 *
	 * @tags accounts
	 * @name UserLogoutV1
	 * @request POST:/v1/accounts/logout
	 */
	userLogoutV1 = (params: RequestParams = {}) =>
		this.request<void, any>({
			path: `/v1/accounts/logout`,
			method: 'POST',
			...params,
		});
	/**
	 * @description API для связывания аккаунта с телеграмм через виджет на сайте
	 *
	 * @tags accounts
	 * @name ConnectTelegramAccountV1
	 * @request POST:/v1/accounts/telegram/connect
	 */
	connectTelegramAccountV1 = (
		data: ConnectTelegramRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			ConnectTelegram400ErrorResponseV1 | ResourceNotFound
		>({
			path: `/v1/accounts/telegram/connect`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Старт привязки Telegram к текущему пользователю через deep-link бота. Возвращает ссылку на бота; сама привязка происходит после нажатия /start.
	 *
	 * @tags accounts
	 * @name ConnectTelegramWithBotV1
	 * @request POST:/v1/accounts/telegram/connect_with_bot
	 */
	connectTelegramWithBotV1 = (params: RequestParams = {}) =>
		this.request<ConnectTelegramWithBotResponseV1, NotAuthorized>({
			path: `/v1/accounts/telegram/connect_with_bot`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления курса
	 *
	 * @tags courses
	 * @name UpdateCourseV1
	 * @request PATCH:/v1/courses/{courseID}
	 */
	updateCourseV1 = (
		courseId: string,
		data: UpdateCourseV1,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, UpdateCoursePlan400Response | ResourceNotFound>({
			path: `/v1/courses/${courseId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения списка задач, доступных пользователю
	 *
	 * @tags courses
	 * @name GetCoursePlanV1
	 * @request GET:/v1/courses/{courseID}/algorithms
	 */
	getCoursePlanV1 = (courseId: string, params: RequestParams = {}) =>
		this.request<AlgoCoursePlanGroupV1, ResourceNotFound>({
			path: `/v1/courses/${courseId}/algorithms`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для удаления прогресса по курсу
	 *
	 * @tags courses
	 * @name DeleteCourseProgressV1
	 * @request DELETE:/v1/courses/{courseID}/progress
	 */
	deleteCourseProgressV1 = (courseId: string, params: RequestParams = {}) =>
		this.request<DeleteUserProgressResponseV1, NotAuthorized>({
			path: `/v1/courses/${courseId}/progress`,
			method: 'DELETE',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения готовых/правильных решений по задачам
	 *
	 * @tags algorithms
	 * @name GetSolutionPromptV1
	 * @request GET:/v1/courses/{courseID}/algorithms/{problemID}/solutions
	 */
	getSolutionPromptV1 = (
		courseId: string,
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<
			SolutionPromptV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/courses/${courseId}/algorithms/${problemId}/solutions`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения готовых/правильных решений по задачам
	 *
	 * @tags algorithms
	 * @name GetSolutionPromptV2
	 * @request GET:/v1/algorithms/{problemID}/solutions
	 */
	getSolutionPromptV2 = (problemId: string, params: RequestParams = {}) =>
		this.request<
			SolutionPromptV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/algorithms/${problemId}/solutions`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения всех языков программирования
	 *
	 * @tags algorithms
	 * @name GetCodeLanguagesV1
	 * @request GET:/v1/courses/{courseID}/algorithms/{problemID}/codeLanguages
	 */
	getCodeLanguagesV1 = (
		courseId: string,
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<CodeLanguagesV1[], ResourceNotFound>({
			path: `/v1/courses/${courseId}/algorithms/${problemId}/codeLanguages`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения всех языков программирования
	 *
	 * @tags algorithms
	 * @name GetCodeLanguagesV2
	 * @request GET:/v1/algorithms/{problemID}/codeLanguages
	 */
	getCodeLanguagesV2 = (problemId: string, params: RequestParams = {}) =>
		this.request<CodeLanguagesV1[], ResourceNotFound>({
			path: `/v1/algorithms/${problemId}/codeLanguages`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения полной информации по проблеме (описание, сложность)
	 *
	 * @tags algorithms
	 * @name GetProblemV1
	 * @request GET:/v1/courses/{courseID}/algorithms/{problemID}/description
	 */
	getProblemV1 = (
		courseId: string,
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<ProblemV1, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/courses/${courseId}/algorithms/${problemId}/description`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения полной информации по проблеме (описание, сложность)
	 *
	 * @tags algorithms
	 * @name GetProblemV2
	 * @request GET:/v1/algorithms/{problemID}/description
	 */
	getProblemV2 = (problemId: string, params: RequestParams = {}) =>
		this.request<ProblemV1, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/algorithms/${problemId}/description`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения списка имен компаний
	 *
	 * @tags algorithms
	 * @name GetCompanyNamesV1
	 * @request GET:/v1/company-names
	 */
	getCompanyNamesV1 = (params: RequestParams = {}) =>
		this.request<string[], NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/company-names`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Генерация задачи с помощью AI
	 *
	 * @tags ai
	 * @name CreateProblemWithAiv1
	 * @request POST:/v1/ai/problems
	 */
	createProblemWithAiv1 = (
		data: CreateProblemWithAIRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			CreateProblemWithAI200ResponseV1,
			| CreateProblemWithAI400ResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
		>({
			path: `/v1/ai/problems`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Получение статуса генерации
	 *
	 * @tags ai
	 * @name GetCreateProblemWithAiStatusV1
	 * @request GET:/v1/ai/problems/{id}
	 */
	getCreateProblemWithAiStatusV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			GetCreateProblemWithAIStatusResponseV1,
			| CreateProblemWithAI400ResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
		>({
			path: `/v1/ai/problems/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления описания
	 *
	 * @tags algorithms
	 * @name UpdateProblemV1
	 * @request PATCH:/v1/problems/{problemID}
	 */
	updateProblemV1 = (
		problemId: string,
		data: UpdateProblemRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
			| UpdateProblemResponse422ErrorV1
		>({
			path: `/v1/problems/${problemId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения полной информации по ресурсам проблемы (код, язык)
	 *
	 * @tags algorithms
	 * @name GetProblemResourcesListV1
	 * @request GET:/v1/courses/{courseID}/algorithms/{problemID}/resources
	 */
	getProblemResourcesListV1 = (
		courseId: string,
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<
			ProblemResourceV1[],
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/courses/${courseId}/algorithms/${problemId}/resources`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения полной информации по ресурсам проблемы (код, язык)
	 *
	 * @tags algorithms
	 * @name GetProblemResourcesListV2
	 * @request GET:/v1/algorithms/{problemID}/resources
	 */
	getProblemResourcesListV2 = (problemId: string, params: RequestParams = {}) =>
		this.request<
			ProblemResourceV1[],
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/algorithms/${problemId}/resources`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления решения пользователя (логин, проблема, код)
	 *
	 * @tags algorithms
	 * @name PostUpdatedSandboxCodeV1
	 * @request PUT:/v1/courses/{courseID}/algorithms/{problemID}/sandbox
	 */
	postUpdatedSandboxCodeV1 = (
		courseId: string,
		problemId: string,
		data: SandboxCodeV1,
		params: RequestParams = {},
	) =>
		this.request<void, any>({
			path: `/v1/courses/${courseId}/algorithms/${problemId}/sandbox`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description API для обновления решения пользователя (логин, проблема, код)
	 *
	 * @tags algorithms
	 * @name PostUpdatedSandboxCodeV2
	 * @request PUT:/v1/algorithms/{problemID}/sandbox
	 */
	postUpdatedSandboxCodeV2 = (
		problemId: string,
		data: SandboxCodeV1,
		params: RequestParams = {},
	) =>
		this.request<void, any>({
			path: `/v1/algorithms/${problemId}/sandbox`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description Получение ссылки на видео-разбор задачи
	 *
	 * @tags videos
	 * @name GetAlgoProblemVideoV1
	 * @request GET:/v1/courses/{courseID}/algorithms/{problemID}/video
	 */
	getAlgoProblemVideoV1 = (
		courseId: string,
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<
			ProblemVideoExplanationV1[],
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/courses/${courseId}/algorithms/${problemId}/video`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Получение ссылки на видео-разбор задачи
	 *
	 * @tags videos
	 * @name GetAlgoProblemVideoV2
	 * @request GET:/v1/algorithms/{problemID}/video
	 */
	getAlgoProblemVideoV2 = (problemId: string, params: RequestParams = {}) =>
		this.request<
			ProblemVideoExplanationV1[],
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/algorithms/${problemId}/video`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения полной информации по тестам (для курсов по языку)
	 *
	 * @tags algorithms
	 * @name GetProblemTestsV1
	 * @request GET:/v1/courses/{courseID}/algorithms/{problemID}/tests
	 */
	getProblemTestsV1 = (
		courseId: string,
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<
			ProblemTestsV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/courses/${courseId}/algorithms/${problemId}/tests`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения полной информации по тестам (для курсов по языку)
	 *
	 * @tags algorithms
	 * @name GetProblemTestsV2
	 * @request GET:/v1/algorithms/{problemID}/tests
	 */
	getProblemTestsV2 = (problemId: string, params: RequestParams = {}) =>
		this.request<
			ProblemTestsV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/algorithms/${problemId}/tests`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания обратной связи по задаче
	 *
	 * @tags feedback
	 * @name PostUserProblemFeedbackV1
	 * @request POST:/v1/problems/{problemID}/feedback
	 */
	postUserProblemFeedbackV1 = (
		problemId: string,
		data: CreateUserFeedbackRequestV1,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/problems/${problemId}/feedback`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для DMG авторизации kinoscope - https://kinescope.notion.site/DRM-8f1feb6ffd984a75bc6b391938bbc766
	 *
	 * @tags videos
	 * @name CheckAccessForKinescopeVideoV1
	 * @request POST:/v1/kinescope/auth
	 */
	checkAccessForKinescopeVideoV1 = (
		data: CheckAccessForKinescopeVideoRequestV1,
		params: RequestParams = {},
	) =>
		this.request<void, NotAuthorized | AccessDenied>({
			path: `/v1/kinescope/auth`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description API для показа подписок
	 *
	 * @tags payment
	 * @name GetSubscriptionsV1
	 * @request GET:/v1/subscriptions
	 */
	getSubscriptionsV1 = (params: RequestParams = {}) =>
		this.request<SubscriptionsResponseV1, ResourceNotFound>({
			path: `/v1/subscriptions`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для показа информации о подписке
	 *
	 * @tags payment
	 * @name GetSubscriptionPaymentInfoV1
	 * @request GET:/v1/subscriptions/{subscriptionID}
	 */
	getSubscriptionPaymentInfoV1 = (
		subscriptionId: string,
		params: RequestParams = {},
	) =>
		this.request<SubscriptionPaymentInfoResponseV1, ResourceNotFound>({
			path: `/v1/subscriptions/${subscriptionId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения информации о доступных тарифах по продукту
	 *
	 * @tags payment
	 * @name GetTariffsProductV1
	 * @request GET:/v1/tariffs/{productID}
	 */
	getTariffsProductV1 = (productId: string, params: RequestParams = {}) =>
		this.request<ProductTariffsResponseV1, any>({
			path: `/v1/tariffs/${productId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения информации о цене по одному тарифу
	 *
	 * @tags payment
	 * @name GetTariffPaymentInfoV1
	 * @request GET:/v1/tariffs/{productID}/{tariffID}
	 */
	getTariffPaymentInfoV1 = (
		productId: string,
		tariffId: string,
		params: RequestParams = {},
	) =>
		this.request<ProductTariffPaymentInfoResponseV1, any>({
			path: `/v1/tariffs/${productId}/${tariffId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Отписка от маркетинговой рассылки. Требует авторизации.
	 *
	 * @tags mailing
	 * @name UnsubscribeFromMailingV1
	 * @request POST:/v1/mailing/unsubscribe
	 */
	unsubscribeFromMailingV1 = (
		data: UnsubscribeFromMailingRequestV1,
		params: RequestParams = {},
	) =>
		this.request<UnsubscribeFromMailingResponseV1, ResourceNotFound>({
			path: `/v1/mailing/unsubscribe`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Вход по одноразовому токену из email-ссылки. Устанавливает auth cookies.
	 *
	 * @tags auth
	 * @name PostAuthLoginByTokenV1
	 * @request POST:/v1/auth/login-by-token
	 */
	postAuthLoginByTokenV1 = (
		data: LoginByTokenRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			CreateAuthTokenResponseV1,
			LoginByToken403ErrorResponse | LoginByToken404ErrorResponse
		>({
			path: `/v1/auth/login-by-token`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Регистрация анонимного пользователя на вебинар. Создает аккаунт, подписывает на UniSender с UTM, отправляет email с кредами.
	 *
	 * @tags webinar
	 * @name AnonymousRegisterForWebinarV1
	 * @request POST:/v1/webinar/{webinarID}/anonymous-register
	 */
	anonymousRegisterForWebinarV1 = (
		webinarId: string,
		data: AnonymousRegisterForWebinarRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			WebinarRegistrationResponseV1,
			AnonymousRegisterForFreeCourse400ResponseV1
		>({
			path: `/v1/webinar/${webinarId}/anonymous-register`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Регистрация авторизованного пользователя на вебинар. Подписывает на UniSender с UTM, отправляет email.
	 *
	 * @tags webinar
	 * @name RegisterForWebinarV1
	 * @request POST:/v1/webinar/{webinarID}/register
	 */
	registerForWebinarV1 = (
		webinarId: string,
		data: RegisterForWebinarRequestV1,
		params: RequestParams = {},
	) =>
		this.request<WebinarRegistrationResponseV1, any>({
			path: `/v1/webinar/${webinarId}/register`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Регистрация на бесплатный продукт (мини-курс). Создает анонимного пользователя, если не залогинен, и подписывает на рассылку через UniSender.
	 *
	 * @tags free-product
	 * @name AnonymousRegisterForFreeCourseV1
	 * @request POST:/v1/courses/{courseID}/anonymous-register
	 */
	anonymousRegisterForFreeCourseV1 = (
		courseId: string,
		data: AnonymousRegisterForFreeCourseV1,
		params: RequestParams = {},
	) =>
		this.request<
			AnonymousRegisterForFreeCourseResponseV1,
			| AnonymousRegisterForFreeCourse400ResponseV1
			| ResourceNotFound
			| UserAlreadyHasPremiumError
		>({
			path: `/v1/courses/${courseId}/anonymous-register`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Регистрация на бесплатный продукт (мини-курс) для действующих пользователей.
	 *
	 * @tags free-product
	 * @name RegisterForFreeCourseV1
	 * @request POST:/v1/courses/{courseID}/register
	 */
	registerForFreeCourseV1 = (
		courseId: string,
		data: RegisterForFreeCourseV1,
		params: RequestParams = {},
	) =>
		this.request<
			RegisterForFreeCourseResponseV1,
			ResourceNotFound | UserAlreadyHasPremiumError
		>({
			path: `/v1/courses/${courseId}/register`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания ссылки на оплату
	 *
	 * @tags payment
	 * @name InitProductPaymentV1
	 * @request POST:/v1/payment
	 */
	initProductPaymentV1 = (
		data: InitProductPaymentV1,
		params: RequestParams = {},
	) =>
		this.request<
			PaymentUrlSuccessV1,
			| CreatePayment400ResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
		>({
			path: `/v1/payment`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Вебхуки для провайдеров
	 *
	 * @tags payment
	 * @name PostPaymentWebhookV1
	 * @request POST:/v1/webhook/payment/{providerID}
	 */
	postPaymentWebhookV1 = (
		providerId: ProviderId,
		data: ContentBlockUnknownV1,
		params: RequestParams = {},
	) =>
		this.request<CRMStageV1, any>({
			path: `/v1/webhook/payment/${providerId}`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description API для проверки/обновления статуса покупки
	 *
	 * @tags payment
	 * @name GetVerifyPaymentV1
	 * @request GET:/v1/payment/{orderID}/verify
	 */
	getVerifyPaymentV1 = (orderId: string, params: RequestParams = {}) =>
		this.request<
			SuccessPaymentV1,
			| VerifySuccessPaymentErrorResponse
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
		>({
			path: `/v1/payment/${orderId}/verify`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для отмены покупки пользователем
	 *
	 * @tags payment
	 * @name PostCancelPaymentV1
	 * @request POST:/v1/payment/{orderID}/cancel
	 */
	postCancelPaymentV1 = (orderId: string, params: RequestParams = {}) =>
		this.request<
			SuccessCancellingPaymentV1,
			NotAuthorized | AccessDenied | ResourceNotFound | OrderNotCancellable
		>({
			path: `/v1/payment/${orderId}/cancel`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description API для проверки валидности промокода
	 *
	 * @tags payment
	 * @name GetPromoCodeV1
	 * @request GET:/v1/promo-codes/{promoCode}
	 */
	getPromoCodeV1 = (promoCode: string, params: RequestParams = {}) =>
		this.request<
			GetPromoCodeResponseV1,
			ValidatePromoCode400ResponseV1 | ResourceNotFound404ResponseV1
		>({
			path: `/v1/promo-codes/${promoCode}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description дополнитяльная ручка API для принудительного пересканирования папок с задачами
	 *
	 * @tags algorithms
	 * @name ForceUpdateAlgorithmsV1
	 * @request POST:/v1/algorithms-force-update
	 */
	forceUpdateAlgorithmsV1 = (
		data: ContentBlockUnknownV1,
		params: RequestParams = {},
	) =>
		this.request<ContentBlockUnknownV1, NotAuthorized | AccessDenied>({
			path: `/v1/algorithms-force-update`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Временная ручка
	 *
	 * @tags algorithms
	 * @name CreateTemporaryProblemV1
	 * @request POST:/v1/create-tmp-problem/{problemID}
	 */
	createTemporaryProblemV1 = (
		problemId: string,
		data: ContentBlockUnknownV1,
		params: RequestParams = {},
	) =>
		this.request<ContentBlockUnknownV1, NotAuthorized | AccessDenied>({
			path: `/v1/create-tmp-problem/${problemId}`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Ручка которая получает zip файл с шаблоном задач из s3
	 *
	 * @tags algorithms
	 * @name GetProblemS3TemplateCodeV1
	 * @request GET:/v1/problems/{problemID}/languages/{langID}/s3-template
	 */
	getProblemS3TemplateCodeV1 = (
		problemId: string,
		langId: number,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, NotAuthorized | AccessDenied>({
			path: `/v1/problems/${problemId}/languages/${langId}/s3-template`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Ручка которая загружает zip файл с шаблоном задач в s3
	 *
	 * @tags algorithms
	 * @name UploadProblemS3TemplateCodeV1
	 * @request POST:/v1/problems/{problemID}/languages/{langID}/s3-template
	 */
	uploadProblemS3TemplateCodeV1 = (
		problemId: string,
		langId: number,
		data: {
			/**
			 * ZIP file containing template code
			 * @format binary
			 */
			file: File;
		},
		query?: {
			etag?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OkResponse, NotAuthorized | AccessDenied>({
			path: `/v1/problems/${problemId}/languages/${langId}/s3-template`,
			method: 'POST',
			query: query,
			body: data,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * @description Ручка которая получает тест файл из s3
	 *
	 * @tags algorithms
	 * @name GetProblemS3TestsV1
	 * @request GET:/v1/problems/{problemID}/s3-tests
	 */
	getProblemS3TestsV1 = (problemId: string, params: RequestParams = {}) =>
		this.request<OkResponse, NotAuthorized | AccessDenied>({
			path: `/v1/problems/${problemId}/s3-tests`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Ручка которая загружает тест файл в s3
	 *
	 * @tags algorithms
	 * @name UploadProblemS3TestsV1
	 * @request POST:/v1/problems/{problemID}/s3-tests
	 */
	uploadProblemS3TestsV1 = (
		problemId: string,
		data: {
			/**
			 * JSON file with tests (tests.json)
			 * @format binary
			 */
			file: File;
		},
		query?: {
			etag?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OkResponse, NotAuthorized | AccessDenied>({
			path: `/v1/problems/${problemId}/s3-tests`,
			method: 'POST',
			query: query,
			body: data,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * @description Ручка возвращает все что сейчас загружено в бакет по этой задаче
	 *
	 * @tags algorithms
	 * @name GetListProblemS3FilesV1
	 * @request GET:/v1/problems/{problemID}/s3-resources
	 */
	getListProblemS3FilesV1 = (problemId: string, params: RequestParams = {}) =>
		this.request<GetListProblemFilesResponseV1, NotAuthorized | AccessDenied>({
			path: `/v1/problems/${problemId}/s3-resources`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Ручка отдает текущее состояние из которого генерировались шаблоны и solutions prompts
	 *
	 * @tags algorithms
	 * @name GetProblemCodeGenStateV1
	 * @request GET:/v1/problems/{problemID}/code-gen-state
	 */
	getProblemCodeGenStateV1 = (problemId: string, params: RequestParams = {}) =>
		this.request<
			ProblemCodeGenStateResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound404ResponseV1
		>({
			path: `/v1/problems/${problemId}/code-gen-state`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Ручка создает s3 ресурсы для обычной алго-задачи
	 *
	 * @tags algorithms
	 * @name PostProblemAlgorithmsTemplatesV1
	 * @request POST:/v1/problems/{problemID}/algorithms-templates
	 */
	postProblemAlgorithmsTemplatesV1 = (
		problemId: string,
		data: PostProblemAlgorithmsTemplatesRequestV1,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, NotAuthorized | AccessDenied>({
			path: `/v1/problems/${problemId}/algorithms-templates`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Ручка создает s3 ресурсы для задачи с классом
	 *
	 * @tags algorithms
	 * @name PostProblemClassAlgorithmsTemplatesV1
	 * @request POST:/v1/problems/{problemID}/class-algorithms-templates
	 */
	postProblemClassAlgorithmsTemplatesV1 = (
		problemId: string,
		data: PostProblemClassAlgorithmsTemplatesRequestV1,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, NotAuthorized | AccessDenied>({
			path: `/v1/problems/${problemId}/class-algorithms-templates`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает текущее состояние из которого генерировались шаблоны для задачи с классом
	 *
	 * @tags algorithms
	 * @name GetProblemClassAlgorithmsCodeGenStateV1
	 * @request GET:/v1/problems/{problemID}/class-algorithms-code-gen-state
	 */
	getProblemClassAlgorithmsCodeGenStateV1 = (
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<
			ProblemClassAlgorithmsCodeGenStateResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound404ResponseV1
		>({
			path: `/v1/problems/${problemId}/class-algorithms-code-gen-state`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения запроса AI анализа
	 *
	 * @tags algorithms
	 * @name PostLastSubmissionAiReportV1
	 * @request POST:/v1/courses/{courseID}/algorithms/{problemID}/submissions/aireport
	 */
	postLastSubmissionAiReportV1 = (
		courseId: string,
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<
			GenerateSubmissionAiReportV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/courses/${courseId}/algorithms/${problemId}/submissions/aireport`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения запроса AI анализа
	 *
	 * @tags algorithms
	 * @name GetLastSubmissionAiReportV1
	 * @request GET:/v1/courses/{courseID}/algorithms/{problemID}/submissions/aireport
	 */
	getLastSubmissionAiReportV1 = (
		courseId: string,
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<
			LastSubmissionAiReportV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/courses/${courseId}/algorithms/${problemId}/submissions/aireport`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания roadmap
	 *
	 * @tags roadmap
	 * @name PostRoadMapV1
	 * @request POST:/v1/roadmaps
	 */
	postRoadMapV1 = (data: CreateRoadMapRequestV1, params: RequestParams = {}) =>
		this.request<CreateRoadMapResponseV1, any>({
			path: `/v1/roadmaps`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения roadmap
	 *
	 * @tags roadmap
	 * @name GetRoadMapV1
	 * @request GET:/v1/roadmaps/{roadmapID}
	 */
	getRoadMapV1 = (roadmapId: string, params: RequestParams = {}) =>
		this.request<
			RoadMapV1,
			UpdateCourse400ErrorResponse | ResourceNotFound404ResponseV1
		>({
			path: `/v1/roadmaps/${roadmapId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления roadmap
	 *
	 * @tags roadmap
	 * @name UpdateRoadMapV1
	 * @request PATCH:/v1/roadmaps/{roadmapID}
	 */
	updateRoadMapV1 = (
		roadmapId: string,
		data: UpdateRoadMapRequestV1,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, ResourceNotFound404ResponseV1>({
			path: `/v1/roadmaps/${roadmapId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения всех курсов (бинарные деревья, связный список etc)
	 *
	 * @tags courses
	 * @name GetCourseListV1
	 * @request GET:/v1/courses
	 */
	getCourseListV1 = (params: RequestParams = {}) =>
		this.request<CoursesV1, any>({
			path: `/v1/courses`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания курса
	 *
	 * @tags courses
	 * @name PostCreateCourseV1
	 * @summary Create course api
	 * @request POST:/v1/courses
	 */
	postCreateCourseV1 = (
		data: CreateCourseRequestV1,
		params: RequestParams = {},
	) =>
		this.request<CreateCourseResponseV1, any>({
			path: `/v1/courses`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name DescriptionV1
	 * @request DESCRIPTION:/v1/courses/{courseID}/theory
	 */
	descriptionV1 = (courseId: string, params: RequestParams = {}) =>
		this.request<any, any>({
			path: `/v1/courses/${courseId}/theory`,
			method: 'DESCRIPTION',
			...params,
		});
	/**
	 * @description API для создания теории в курсе
	 *
	 * @tags theory
	 * @name CreateCourseTheoryV1
	 * @summary Create theory for course
	 * @request POST:/v1/courses/{courseID}/theory
	 */
	createCourseTheoryV1 = (
		courseId: string,
		data: CreateTheoryRequestV1,
		params: RequestParams = {},
	) =>
		this.request<CourseTheoryIDV1, any>({
			path: `/v1/courses/${courseId}/theory`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name DescriptionV12
	 * @request DESCRIPTION:/v1/courses/{courseID}/theory/{theoryID}
	 * @originalName descriptionV1
	 * @duplicate
	 */
	descriptionV12 = (
		courseId: string,
		theoryId: string,
		params: RequestParams = {},
	) =>
		this.request<any, any>({
			path: `/v1/courses/${courseId}/theory/${theoryId}`,
			method: 'DESCRIPTION',
			...params,
		});
	/**
	 * @description API для получения всех id уроков теории
	 *
	 * @tags theory
	 * @name GetTheoryV1
	 * @summary Get theory
	 * @request GET:/v1/courses/{courseID}/theory/{theoryID}
	 */
	getTheoryV1 = (
		courseId: string,
		theoryId: string,
		params: RequestParams = {},
	) =>
		this.request<TheoryV1, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/courses/${courseId}/theory/${theoryId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Change title or order of lessons
	 *
	 * @tags theory
	 * @name UpdateTheoryV1
	 * @summary Update theory
	 * @request PUT:/v1/courses/{courseID}/theory/{theoryID}
	 */
	updateTheoryV1 = (
		courseId: string,
		theoryId: string,
		data: UpdateTheoryRequestV1,
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/v1/courses/${courseId}/theory/${theoryId}`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description Create empty lesson, add it at the end of theory
	 *
	 * @tags theory
	 * @name AddLessonToTheoryV1
	 * @summary Add new lesson
	 * @request POST:/v1/courses/{courseID}/theory/{theoryID}
	 */
	addLessonToTheoryV1 = (
		courseId: string,
		theoryId: string,
		data: CreateTheoryLessonRequestV1,
		params: RequestParams = {},
	) =>
		this.request<TheoryLessonIdV1, any>({
			path: `/v1/courses/${courseId}/theory/${theoryId}`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для поиска по урокам
	 *
	 * @tags theory
	 * @name GetLessonsV1
	 * @request GET:/v1/lessons
	 */
	getLessonsV1 = (
		query: {
			/**
			 * Начальный индекс для пагинации
			 * @min 0
			 */
			offset: number;
			/**
			 * Количество теории на странице
			 * @min 1
			 * @max 100
			 */
			limit: number;
			/** Фильтр теории по видимости (true/false) */
			visible?: boolean;
			/** Фильтр по имени теории */
			title?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			LessonListResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/lessons`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания урока
	 *
	 * @tags theory
	 * @name CreateLessonV1
	 * @request POST:/v1/lessons
	 */
	createLessonV1 = (data: CreateLessonRequestV1, params: RequestParams = {}) =>
		this.request<
			CreateLessonResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/lessons`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для загрузки курса с полной структурой (1 план, 1 топик, N подтопиков)
	 *
	 * @tags courses
	 * @name ImportCourseLoaderV1
	 * @request POST:/v1/courses/loader
	 */
	importCourseLoaderV1 = (
		data: ImportCourseRequestV1,
		params: RequestParams = {},
	) =>
		this.request<ImportCourseResponseV1, NotAuthorized | AccessDenied>({
			path: `/v1/courses/loader`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для загрузки готового урока теории с контентом
	 *
	 * @tags theory
	 * @name ImportLessonLoaderV1
	 * @request POST:/v1/lessons/loader
	 */
	importLessonLoaderV1 = (
		data: ImportLessonRequestV1,
		params: RequestParams = {},
	) =>
		this.request<ImportLessonResponseV1, NotAuthorized | AccessDenied>({
			path: `/v1/lessons/loader`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения отдельного урока
	 *
	 * @tags singleLesson
	 * @name GetLessonV1
	 * @summary Get single lesson
	 * @request GET:/v1/lessons/{lessonID}
	 */
	getLessonV1 = (lessonId: string, params: RequestParams = {}) =>
		this.request<
			StaticLessonV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/lessons/${lessonId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления описания
	 *
	 * @tags theory
	 * @name UpdateLessonV1
	 * @request PATCH:/v1/lessons/{lessonID}
	 */
	updateLessonV1 = (
		lessonId: string,
		data: UpdateLessonRequestV1,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/lessons/${lessonId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для пометки теории пройденной
	 *
	 * @tags theory
	 * @name PostLessonPassV1
	 * @request POST:/v1/lessons/{lessonID}/pass
	 */
	postLessonPassV1 = (lessonId: string, params: RequestParams = {}) =>
		this.request<
			CreateTheoryPassResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/lessons/${lessonId}/pass`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name DescriptionV13
	 * @request DESCRIPTION:/v1/courses/{courseID}/theory/lessons/{lessonID}
	 * @originalName descriptionV1
	 * @duplicate
	 */
	descriptionV13 = (
		courseId: string,
		lessonId: string,
		params: RequestParams = {},
	) =>
		this.request<any, any>({
			path: `/v1/courses/${courseId}/theory/lessons/${lessonId}`,
			method: 'DESCRIPTION',
			...params,
		});
	/**
	 * @description API для получения отдельного урока
	 *
	 * @tags singleLesson
	 * @name GetSingleStaticLessonV1
	 * @summary Get single lesson
	 * @request GET:/v1/courses/{courseID}/theory/lessons/{lessonID}
	 */
	getSingleStaticLessonV1 = (
		courseId: string,
		lessonId: string,
		params: RequestParams = {},
	) =>
		this.request<
			StaticLessonV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/courses/${courseId}/theory/lessons/${lessonId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для пометки теории пройденной
	 *
	 * @tags theory
	 * @name PostLessonPassLegacyV1
	 * @request POST:/v1/courses/{courseID}/theory/lessons/{lessonID}/pass
	 */
	postLessonPassLegacyV1 = (
		courseId: string,
		lessonId: string,
		params: RequestParams = {},
	) =>
		this.request<
			CreateTheoryPassResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/courses/${courseId}/theory/lessons/${lessonId}/pass`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания обратной связи по теории
	 *
	 * @tags feedback
	 * @name PostUserTheoryFeedbackV1
	 * @request POST:/v1/lessons/{lessonID}/feedback
	 */
	postUserTheoryFeedbackV1 = (
		lessonId: string,
		data: CreateUserFeedbackRequestV1,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/lessons/${lessonId}/feedback`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Get state of the task: solved or not solved
	 *
	 * @tags task
	 * @name IsSolvedV1
	 * @summary Get task state
	 * @request GET:/v1/courses/{courseID}/theory/{theoryID}/tasks/{taskID}/solved
	 */
	isSolvedV1 = (
		courseId: string,
		theoryId: string,
		taskId: string,
		params: RequestParams = {},
	) =>
		this.request<SolvedTask, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/courses/${courseId}/theory/${theoryId}/tasks/${taskId}/solved`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Attempt to solve a task. Send to server taskId and answer.
	 *
	 * @tags task
	 * @name SubmitAnswerV1
	 * @summary Submit answer
	 * @request POST:/v1/courses/{courseID}/theory/{theoryID}/tasks/{taskID}/submissions
	 */
	submitAnswerV1 = (
		courseId: string,
		theoryId: string,
		taskId: string,
		data: TheoryTestsUserSubmissionsV1,
		params: RequestParams = {},
	) =>
		this.request<void, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/courses/${courseId}/theory/${theoryId}/tasks/${taskId}/submissions`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			...params,
		});
	/**
	 * @description Get result of previously submitted question. Is used to show student right answer even after page was reload
	 *
	 * @tags task
	 * @name GetAnswerV1
	 * @summary Get answer
	 * @request GET:/v1/courses/{courseID}/theory/{theoryID}/tasks/{taskID}/submissions/last
	 */
	getAnswerV1 = (
		courseId: string,
		theoryId: string,
		taskId: string,
		params: RequestParams = {},
	) =>
		this.request<
			TheoryTestsAnswerV1,
			void | NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/courses/${courseId}/theory/${theoryId}/tasks/${taskId}/submissions/last`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для отправки тестов
	 *
	 * @tags theoryTest
	 * @name PostTheoryTestV1
	 * @request POST:/v1/theoryTests/{testID}
	 */
	postTheoryTestV1 = (
		testId: string,
		data: TheoryTestRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			TheoryTestSubmissionResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/theoryTests/${testId}`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения списка фидбэков сгрупированных по задачам/теориям
	 *
	 * @tags problem
	 * @name GetFeedbacksV1
	 * @request GET:/v1/feedbacks
	 */
	getFeedbacksV1 = (
		query: {
			/** Фидбэк задачи/теории */
			feedbackTarget?: FeedbackTargetEnumV1;
			/** Фильтр фидбэка по isResolved */
			resolved?: boolean;
			/** Начальный индекс для пагинации */
			offset: number;
			/** Количество фидбэков на странице */
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<FeedbackListResponseV1, NotAuthorized | AccessDenied>({
			path: `/v1/feedbacks`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description API для пометки фидбэка как решенного
	 *
	 * @tags theory
	 * @name PostFeedbackResolvedV1
	 * @request POST:/v1/feedbacks/{id}/resolve
	 */
	postFeedbackResolvedV1 = (id: string, params: RequestParams = {}) =>
		this.request<OkResponse, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/feedbacks/${id}/resolve`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description API для пометки фидбэка как нерешенного
	 *
	 * @tags theory
	 * @name PostFeedbackUnresolvedV1
	 * @request POST:/v1/feedbacks/{id}/unresolve
	 */
	postFeedbackUnresolvedV1 = (id: string, params: RequestParams = {}) =>
		this.request<OkResponse, NotAuthorized | AccessDenied | ResourceNotFound>({
			path: `/v1/feedbacks/${id}/unresolve`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения списка задач
	 *
	 * @tags problem
	 * @name GetProblemsV1
	 * @request GET:/v1/problems
	 */
	getProblemsV1 = (
		query: {
			/** Тип задачи (algorithm, system-design, golang) */
			category: ProblemCategoryEnum;
			company?: string[];
			/** Фильтр задач по статусу решения (true/false) */
			solved?: boolean;
			/**
			 * Начальный индекс для пагинации
			 * @min 0
			 * @default 0
			 */
			offset?: number;
			/**
			 * Количество задач на странице
			 * @min 1
			 * @max 100
			 * @default 100
			 */
			limit?: number;
			/** Фильтр задач по видимости (true/false) */
			visible?: boolean;
			/** Фильтр по имени задачи */
			title?: string;
			/** Фильтр по уровню доступа (только для администраторов) */
			permissionLevel?: PermissionLevelV1;
		},
		params: RequestParams = {},
	) =>
		this.request<ProblemListV1, NotAuthorized | AccessDenied>({
			path: `/v1/problems`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания алго/golang/sql задачи
	 *
	 * @tags algorithms
	 * @name CreateProblemV1
	 * @request POST:/v1/problems
	 */
	createProblemV1 = (
		data: CreateProblemRequestV1,
		params: RequestParams = {},
	) =>
		this.request<CreateProblemResponseV1, void>({
			path: `/v1/problems`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для загрузки готовой задачи с шаблонами и текстом
	 *
	 * @tags algorithms
	 * @name ImportProblemLoaderV1
	 * @request POST:/v1/problems/loader
	 */
	importProblemLoaderV1 = (
		data: ImportProblemRequestV1,
		params: RequestParams = {},
	) =>
		this.request<ImportProblemResponseV1, any>({
			path: `/v1/problems/loader`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для выполнения пользовательского запроса
	 *
	 * @tags algorithms
	 * @name PostProblemSubmissionV1
	 * @request POST:/v1/problems/{problemID}/submissions
	 */
	postProblemSubmissionV1 = (
		problemId: string,
		data: SubmitRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			SubmitResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound404ResponseV1
		>({
			path: `/v1/problems/${problemId}/submissions`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения статуса сабмита
	 *
	 * @tags algorithms
	 * @name GetProblemSubmissionV1
	 * @request GET:/v1/problems/{problemID}/submissions/{submissionID}
	 */
	getProblemSubmissionV1 = (
		problemId: string,
		submissionId: string,
		params: RequestParams = {},
	) =>
		this.request<
			SubmissionResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound404ResponseV1
		>({
			path: `/v1/problems/${problemId}/submissions/${submissionId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения статуса последнего удачного сабмита
	 *
	 * @tags algorithms
	 * @name GetLastProblemSubmissionV1
	 * @request GET:/v1/problems/{problemID}/submissions/last
	 */
	getLastProblemSubmissionV1 = (
		problemId: string,
		params: RequestParams = {},
	) =>
		this.request<
			SubmissionResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound404ResponseV1
		>({
			path: `/v1/problems/${problemId}/submissions/last`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Выполнить произвольный read-only SQL-запрос (только для админов). Разрешены только SELECT-запросы, выполняются в read-only транзакции.
	 *
	 * @tags system
	 * @name PostSecretSqlv1
	 * @request POST:/v1/admin/secret-sql
	 */
	postSecretSqlv1 = (data: SecretSQLRequestV1, params: RequestParams = {}) =>
		this.request<
			SecretSQLResponseV1,
			SecretSQL400Response | NotAuthorized | AccessDenied
		>({
			path: `/v1/admin/secret-sql`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Добавить премиум к пользователю
	 *
	 * @tags users
	 * @name PostAdminGrantUserSubscriptionV1
	 * @request POST:/v1/admin/users/{userLogin}/subscription/grant
	 */
	postAdminGrantUserSubscriptionV1 = (
		userLogin: string,
		data: GrantPremiumForUserV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			GrantPremiumDetailedErrorResponseV1 | NotAuthorized | AccessDenied
		>({
			path: `/v1/admin/users/${userLogin}/subscription/grant`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Редактировать пользователя
	 *
	 * @tags users
	 * @name UpdateAdminUserV1
	 * @request PATCH:/v1/admin/users/{userID}
	 */
	updateAdminUserV1 = (
		userId: string,
		data: UpdateAdminUserRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| UpdateAdminUser400Response
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
		>({
			path: `/v1/admin/users/${userId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Поиск по пользователям
	 *
	 * @tags users
	 * @name GetAdminSearchUsersV1
	 * @request GET:/v1/admin/users
	 */
	getAdminSearchUsersV1 = (
		query: {
			term?: string;
			offset: number;
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<UserSearchListV1, NotAuthorized | AccessDenied>({
			path: `/v1/admin/users`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Получает аудит по подписке пользователя
	 *
	 * @tags users
	 * @name GetAdminUserSubscriptionAuditV1
	 * @request GET:/v1/admin/users/{userLogin}/subscription-audits
	 */
	getAdminUserSubscriptionAuditV1 = (
		userLogin: string,
		query: {
			offset: number;
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<UserSubscriptionAuditListV1, NotAuthorized | AccessDenied>({
			path: `/v1/admin/users/${userLogin}/subscription-audits`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения активных системных уведомлений
	 *
	 * @tags system-notifications
	 * @name ListActiveSystemNotificationsV1
	 * @request GET:/v1/system-notifications
	 */
	listActiveSystemNotificationsV1 = (params: RequestParams = {}) =>
		this.request<SystemNotificationsListV1, NotAuthorized | AccessDenied>({
			path: `/v1/system-notifications`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для получения всех системных уведомлений
	 *
	 * @tags system-notifications
	 * @name ListSystemNotificationsAdminV1
	 * @request GET:/v1/admin/system-notifications
	 */
	listSystemNotificationsAdminV1 = (params: RequestParams = {}) =>
		this.request<SystemNotificationsAdminListV1, NotAuthorized | AccessDenied>({
			path: `/v1/admin/system-notifications`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description API для создания системного уведомления
	 *
	 * @tags system-notifications
	 * @name CreateSystemNotificationAdminV1
	 * @request POST:/v1/admin/system-notifications
	 */
	createSystemNotificationAdminV1 = (
		data: CreateSystemNotificationRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			SystemNotification400ErrorResponseV1 | NotAuthorized | AccessDenied
		>({
			path: `/v1/admin/system-notifications`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления системного уведомления
	 *
	 * @tags system-notifications
	 * @name UpdateSystemNotificationAdminV1
	 * @request PATCH:/v1/admin/system-notifications/{notificationID}
	 */
	updateSystemNotificationAdminV1 = (
		notificationId: string,
		data: UpdateSystemNotificationRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| SystemNotification400ErrorResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
			| UpdateSystemNotification409ErrorResponseV1
		>({
			path: `/v1/admin/system-notifications/${notificationId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description API для отправки ежедневного отчёта по платежам
	 *
	 * @tags payment
	 * @name CronSendDailyPaymentsReportV1
	 * @request POST:/v1/internal/cron/reports/daily-payments
	 */
	cronSendDailyPaymentsReportV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/reports/daily-payments`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления застрявших записей
	 *
	 * @tags payment
	 * @name CronUnlockStuckEventsV1
	 * @request POST:/v1/internal/cron/outbox/unlock
	 */
	cronUnlockStuckEventsV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/outbox/unlock`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Проверить очередную пачку CRM-клиентов и поставить автоматические AI-задачи. Реактивация создаётся только при включённом CRM-топике system.reactivation, назначенном менеджере и активной продуктовой подписке.
	 *
	 * @tags crm
	 * @name CronProcessAutomaticCrmTasksV1
	 * @request POST:/v1/internal/cron/crm/process-automatic-tasks
	 */
	cronProcessAutomaticCrmTasksV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/crm/process-automatic-tasks`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description API для обновления закончившихся interview
	 *
	 * @tags payment
	 * @name CronInterviewProcessTimeoutsV1
	 * @request POST:/v1/internal/cron/interviews/process-timeouts
	 */
	cronInterviewProcessTimeoutsV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/interviews/process-timeouts`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Выполнить рекуррентные платежи по подпискам
	 *
	 * @tags payment
	 * @name CronPerformSubscriptionPaymentsV1
	 * @request POST:/v1/internal/cron/payment/perform-subscriptions
	 */
	cronPerformSubscriptionPaymentsV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/payment/perform-subscriptions`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Синхронизировать статусы платежей с провайдером
	 *
	 * @tags payment
	 * @name CronVerifyStatusesV1
	 * @request POST:/v1/internal/cron/payment/verify-statuses
	 */
	cronVerifyStatusesV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/payment/verify-statuses`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Подтвердить ожидающие заказы
	 *
	 * @tags payment
	 * @name CronCommitOrdersV1
	 * @request POST:/v1/internal/cron/payment/commit-orders
	 */
	cronCommitOrdersV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/payment/commit-orders`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Отправить уведомления о предстоящих рекуррентных платежах
	 *
	 * @tags payment
	 * @name CronSendRecurrentNotificationEmailV1
	 * @request POST:/v1/internal/cron/payment/notify-recurrent
	 */
	cronSendRecurrentNotificationEmailV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/payment/notify-recurrent`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Уведомить комьюнити-менеджеров о закончившихся подписках
	 *
	 * @tags payment
	 * @name CronNotifyExpiredSubscriptionsV1
	 * @request POST:/v1/internal/cron/payment/notify-expired-subscriptions
	 */
	cronNotifyExpiredSubscriptionsV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/payment/notify-expired-subscriptions`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Забанить пользователей с истёкшей подпиской в Telegram
	 *
	 * @tags telegram
	 * @name CronBanUsersV1
	 * @request POST:/v1/internal/cron/telegram/ban-users
	 */
	cronBanUsersV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/telegram/ban-users`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name GetInterviewSimulatorV1
	 * @summary Get simulator interview info
	 * @request GET:/v1/interview-simulator/{id}
	 */
	getInterviewSimulatorV1 = (id: string, params: RequestParams = {}) =>
		this.request<GetInterviewSimulatorResponseV1, any>({
			path: `/v1/interview-simulator/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name GetAllUserInterviewsV1
	 * @summary Get all user interviews
	 * @request GET:/v1/interviews
	 */
	getAllUserInterviewsV1 = (
		query: {
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<GetAllUserInterviewsResponseV1, any>({
			path: `/v1/interviews`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name CreateUserInterviewV1
	 * @summary Create new interview
	 * @request POST:/v1/interviews
	 */
	createUserInterviewV1 = (
		data: PostCreateUserInterviewV1,
		params: RequestParams = {},
	) =>
		this.request<
			CreateUserInterviewResponseV1,
			CreateUserInterview400ErrorResponse
		>({
			path: `/v1/interviews`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name GetCurrentInterviewsV1
	 * @summary Get current active interview for user
	 * @request GET:/v1/interviews/active
	 */
	getCurrentInterviewsV1 = (params: RequestParams = {}) =>
		this.request<GetUserInterviewResponseV1, any>({
			path: `/v1/interviews/active`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name GetUserInterviewV1
	 * @summary Get interview state
	 * @request GET:/v1/interviews/{id}
	 */
	getUserInterviewV1 = (id: string, params: RequestParams = {}) =>
		this.request<GetUserInterviewResponseV1, ResourceNotFound>({
			path: `/v1/interviews/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @name FinishUserInterviewV1
	 * @summary Finish interview manually
	 * @request POST:/v1/interviews/{id}/finish
	 */
	finishUserInterviewV1 = (id: string, params: RequestParams = {}) =>
		this.request<OkResponse, void | ResourceNotFound>({
			path: `/v1/interviews/${id}/finish`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name GetAiProblemV1
	 * @request GET:/v1/ai-problems/{problemId}
	 */
	getAiProblemV1 = (problemId: string, params: RequestParams = {}) =>
		this.request<GetAIProblemResponseV1, any>({
			path: `/v1/ai-problems/${problemId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Saves feedback for an accessible AI problem using the current JWT user.
	 *
	 * @tags feedback
	 * @name PostUserAiProblemFeedbackV1
	 * @request POST:/v1/ai-problems/{problemId}/feedback
	 */
	postUserAiProblemFeedbackV1 = (
		problemId: string,
		data: CreateUserAIProblemFeedbackRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			InvalidFeedbackInputV1 | NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/ai-problems/${problemId}/feedback`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает статические данные для «leetcode»-отображения ai-algo задачи одним GET: условие, видео и по каждому языку — стартовый шаблон и эталонное решение. Все текстовые поля — Markdown. Данные берутся из render-таблиц ai_algo_problem_content_md и ai_algo_problem_language_content_md и не связаны с ходом диалога. 404, если у задачи нет render-контента (не ai-algo задача либо контент не засеян).
	 *
	 * @tags ai-interview
	 * @name GetAiAlgoProblemContentV1
	 * @summary Leetcode-style render view for an ai-algo problem (all fields Markdown)
	 * @request GET:/v1/ai-algo-problems/{problemId}/content
	 */
	getAiAlgoProblemContentV1 = (problemId: string, params: RequestParams = {}) =>
		this.request<GetAIAlgoProblemContentResponseV1, ResourceNotFound>({
			path: `/v1/ai-algo-problems/${problemId}/content`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Сохраняет черновик пользователя (один или несколько файлов) для ai-algo задачи в выбранном языке — мультифайловый аналог PUT /v1/algorithms/{problemID}/sandbox для нового формата. Идемпотентный upsert по (пользователь, задача, язык): повторный вызов заменяет ранее сохранённый черновик для этого языка (пустой список files очищает черновик). Возвращает сохранённый черновик. 404, если задача не ai-algo.
	 *
	 * @tags ai-interview
	 * @name PutAiAlgoSandboxV1
	 * @summary Save the caller's multi-file working draft for an ai-algo problem in one language
	 * @request PUT:/v1/ai-algo-problems/{problemId}/sandbox
	 */
	putAiAlgoSandboxV1 = (
		problemId: string,
		data: UpdateAIAlgoSandboxRequestV1,
		params: RequestParams = {},
	) =>
		this.request<AIAlgoSandboxV1, ResourceNotFound>({
			path: `/v1/ai-algo-problems/${problemId}/sandbox`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает сохранённые черновики пользователя для ai-algo задачи — по одному на язык, для которого черновик был сохранён. Пустой список, если черновиков нет. 404, если задача не ai-algo.
	 *
	 * @tags ai-interview
	 * @name GetAiAlgoSandboxV1
	 * @summary The caller's saved multi-file drafts for an ai-algo problem (all languages)
	 * @request GET:/v1/ai-algo-problems/{problemId}/sandbox
	 */
	getAiAlgoSandboxV1 = (problemId: string, params: RequestParams = {}) =>
		this.request<GetAIAlgoSandboxResponseV1, ResourceNotFound>({
			path: `/v1/ai-algo-problems/${problemId}/sandbox`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Создаёт сабмит и запускает присланный код против тестов связанной algorithms-задачи (как code-задача в диалоге) асинхронно. Немедленно возвращает созданный сабмит в статусе `processing` (с его id) — вердикт (verdictMd) появляется позже, когда проверка завершится. Клиент опрашивает GET по id, пока status не станет терминальным (accepted, wrong_answer, runtime_error и т.п.). Историю сабмитов можно листать пагинированно (GET) и открывать по id.
	 *
	 * @tags ai-interview
	 * @name PostAiAlgoSubmissionV1
	 * @summary Submit code for an ai-algo problem; creates a submission and runs it asynchronously
	 * @request POST:/v1/ai-algo-problems/{problemId}/submissions
	 */
	postAiAlgoSubmissionV1 = (
		problemId: string,
		data: SubmitAIAlgoCodeRequestV1,
		params: RequestParams = {},
	) =>
		this.request<AIAlgoSubmissionV1, ResourceNotFound>({
			path: `/v1/ai-algo-problems/${problemId}/submissions`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name ListAiAlgoSubmissionsV1
	 * @summary Paginated history of the caller's submissions for an ai-algo problem (newest first)
	 * @request GET:/v1/ai-algo-problems/{problemId}/submissions
	 */
	listAiAlgoSubmissionsV1 = (
		problemId: string,
		query: {
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<ListAIAlgoSubmissionsResponseV1, any>({
			path: `/v1/ai-algo-problems/${problemId}/submissions`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает последний по времени сабмит пользователя для задачи — любой статус (не только accepted), с полным Markdown-вердиктом и кодом. Резолвится за один lookup через таблицу-указатель ai_algo_last_submission, статус/вердикт всегда актуальные. Нет сабмитов → 404.
	 *
	 * @tags ai-interview
	 * @name GetLastAiAlgoSubmissionV1
	 * @summary The caller's most recent submission for an ai-algo problem (any status)
	 * @request GET:/v1/ai-algo-problems/{problemId}/submissions/last
	 */
	getLastAiAlgoSubmissionV1 = (problemId: string, params: RequestParams = {}) =>
		this.request<AIAlgoSubmissionV1, ResourceNotFound>({
			path: `/v1/ai-algo-problems/${problemId}/submissions/last`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name GetAiAlgoSubmissionV1
	 * @summary One ai-algo submission with its full Markdown verdict and submitted code
	 * @request GET:/v1/ai-algo-problems/{problemId}/submissions/{submissionId}
	 */
	getAiAlgoSubmissionV1 = (
		problemId: string,
		submissionId: string,
		params: RequestParams = {},
	) =>
		this.request<AIAlgoSubmissionV1, ResourceNotFound>({
			path: `/v1/ai-algo-problems/${problemId}/submissions/${submissionId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name GetAdminAiProblemV1
	 * @summary Admin — full ai-problem with all tasks in one JSON
	 * @request GET:/v1/admin/ai-problems/{problemId}
	 */
	getAdminAiProblemV1 = (problemId: string, params: RequestParams = {}) =>
		this.request<
			GetAdminAIProblemResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/admin/ai-problems/${problemId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Принимает тот же JSON, что возвращает getAdminAIProblemV1, с изменёнными данными. Обновляет поля ai_problem и содержимое существующих задач (config / initialMessage / type), сопоставляя задачи по id. Не добавляет, не удаляет и не переупорядочивает задачи — массив tasks должен содержать задачи, уже принадлежащие этой проблеме.
	 *
	 * @tags ai-interview
	 * @name UpdateAdminAiProblemV1
	 * @summary Admin — update an ai-problem and its tasks in place
	 * @request PUT:/v1/admin/ai-problems/{problemId}
	 */
	updateAdminAiProblemV1 = (
		problemId: string,
		data: UpdateAdminAIProblemRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			GetAdminAIProblemResponseV1,
			| UpdateAdminAIProblem400ResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
		>({
			path: `/v1/admin/ai-problems/${problemId}`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Atomically creates a standalone execution, a hidden ai-algo problem, its Markdown render content, company tags, starter files and optional reference solutions. Existing problems or executions are never updated: an occupied id returns 409. Every supplied reference solution is executed against the requested execution before anything is persisted.
	 *
	 * @tags ai-interview
	 * @name CreateAdminAiAlgoProblemV1
	 * @summary Admin — create a hidden ai-algo problem with Markdown content
	 * @request POST:/v1/admin/ai-algo-problems
	 */
	createAdminAiAlgoProblemV1 = (
		data: CreateAdminAIAlgoProblemRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			GetAIAlgoProblemContentResponseV1,
			| UpdateAdminAIAlgoContent400ResponseV1
			| NotAuthorized
			| AccessDenied
			| CreateAdminAIAlgoProblem409ResponseV1
			| UpdateAdminAIAlgoContent422ResponseV1
		>({
			path: `/v1/admin/ai-algo-problems`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Обновляет авторский контент ai-algo задачи: заголовок, условие, видео (Markdown), по каждому языку — эталонное решение (Markdown) и стартовый шаблон (набор файлов). solutions полностью заменяют набор решений; starterFiles — пер-языковой патч: перечисленные языки получают новый стартовый шаблон и помечаются как авторские, после чего перегенерация шаблонов их больше не перезаписывает. Аналог UpdateAdminAIProblemV1, но принимает Markdown вместо pagerenderer. Не меняет привязку исполнения (execution) и флаги доступа. 404, если задача не найдена или не является ai-algo задачей.
	 *
	 * @tags ai-interview
	 * @name UpdateAdminAiAlgoContentV1
	 * @summary Admin — update an ai-algo problem's Markdown render content in place
	 * @request PATCH:/v1/admin/ai-algo-problems/{problemId}/content
	 */
	updateAdminAiAlgoContentV1 = (
		problemId: string,
		data: UpdateAdminAIAlgoContentRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			GetAIAlgoProblemContentResponseV1,
			| UpdateAdminAIAlgoContent400ResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
			| UpdateAdminAIAlgoContent422ResponseV1
		>({
			path: `/v1/admin/ai-algo-problems/${problemId}/content`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Генерирует шаблоны и стартовый код для ai-algo execution (набора фикстур) и раскладывает их по его s3-префиксу. Одна ручка на обе формы задачи — тело это oneOf по полю `kind`: `function` (обычная алго-задача: имя функции, типы аргументов, тип результата) и `class` (задача с классом: имя класса, конструктор, методы). Для каждого языка генерируется архив шаблона (кладётся в `{префикс}/{язык}.zip`) и стартовый код, который записывается в per-language контент ai-algo задач, привязанных к этому execution. Языки, чей стартовый шаблон был проставлен вручную через PATCH .../content, пропускаются. Присланная спека сохраняется как code-gen-state этого execution и возвращается из GET .../code-gen-state. Ручка НЕ трогает `problems` и legacy-ручки /v1/problems/{problemID}/*.
	 *
	 * @tags ai-interview
	 * @name PostAiAlgoExecutionTemplatesV1
	 * @summary Admin — generate an ai-algo execution's per-language template archives
	 * @request POST:/v1/admin/ai-algo-executions/{executionId}/templates
	 */
	postAiAlgoExecutionTemplatesV1 = (
		executionId: string,
		data: AIAlgoTemplatesSpecV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| AIAlgoTemplates400ResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
			| AIAlgoTemplates422ResponseV1
		>({
			path: `/v1/admin/ai-algo-executions/${executionId}/templates`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает всё, что сейчас лежит в s3-папке этого execution: по объекту на язык (`{язык}.zip`) и, обычно, `tests.json`. Аналог GET /v1/problems/{problemID}/s3-resources, но для набора фикстур, а не для задачи из каталога. Имена файлов из этого списка — ровно то, что принимают GET/PUT .../files/{fileName}. Если у execution задан `tests_key` (он переиспользует чужие архивы шаблонов, но со своими тестами) и этот объект лежит ВНЕ папки, он всё равно попадает в список — иначе список показывал бы не то, на чём реально запускается код. 404, если execution не найден.
	 *
	 * @tags ai-interview
	 * @name GetAiAlgoExecutionFilesV1
	 * @summary Admin — list the fixture objects stored for an ai-algo execution
	 * @request GET:/v1/admin/ai-algo-executions/{executionId}/files
	 */
	getAiAlgoExecutionFilesV1 = (
		executionId: string,
		params: RequestParams = {},
	) =>
		this.request<
			GetAIAlgoExecutionFilesResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/admin/ai-algo-executions/${executionId}/files`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Отдаёт объект байтами (`application/octet-stream`). `fileName` — имя из списка GET .../files: либо архив шаблона `{язык}.zip` (python, cpp, golang, java, csharp, javascript), либо `tests.json`. Любое другое имя — 400: раскладка знает ровно эти два вида объектов, и произвольный путь здесь означал бы сборку s3-ключа в обход неё. Кэш фикстур игнорируется, так что редактор всегда видит то, что реально лежит в бакете. Для `tests.json` учитывается `tests_key`: скачивается тот объект, против которого реально запускается код, даже если он лежит в другой папке.
	 *
	 * @tags ai-interview
	 * @name GetAiAlgoExecutionFileV1
	 * @summary Admin — download one fixture object of an ai-algo execution
	 * @request GET:/v1/admin/ai-algo-executions/{executionId}/files/{fileName}
	 */
	getAiAlgoExecutionFileV1 = (
		executionId: string,
		fileName: string,
		params: RequestParams = {},
	) =>
		this.request<
			File,
			| AIAlgoExecutionFile400ResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
		>({
			path: `/v1/admin/ai-algo-executions/${executionId}/files/${fileName}`,
			method: 'GET',
			...params,
		});
	/**
	 * @description Загружает объект в s3-папку execution. `fileName` тот же, что у GET: `{язык}.zip` или `tests.json`; для `tests.json` учитывается `tests_key`, так что запись идёт ровно туда, откуда читает запуск. Необязательный `etag` — оптимистичная блокировка: если он не совпадает с текущим, запись отклоняется с 400 `dirty_version`, чтобы два редактора не затирали друг друга (тот же код и тот же статус, что у загрузки файлов задачи из каталога). Отказывает с 422, если фикстуры по этому пути уже читает что-то опубликованное — те же условия, что у POST .../templates: видимая ai-algo задача (через render-привязку или через `executionId` code-задачи, в том числе у другого execution в той же папке) либо видимая задача каталога, если папка — её собственная `{категория}/{problemID}/`.
	 *
	 * @tags ai-interview
	 * @name UploadAiAlgoExecutionFileV1
	 * @summary Admin — upload one fixture object of an ai-algo execution
	 * @request PUT:/v1/admin/ai-algo-executions/{executionId}/files/{fileName}
	 */
	uploadAiAlgoExecutionFileV1 = (
		executionId: string,
		fileName: string,
		data: {
			/**
			 * Содержимое объекта: zip-архив шаблона или JSON с тестами.
			 * @format binary
			 */
			file: File;
		},
		query?: {
			/** ETag текущего объекта; при несовпадении запись отклоняется. */
			etag?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| AIAlgoExecutionFile400ResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound
			| AIAlgoTemplates422ResponseV1
		>({
			path: `/v1/admin/ai-algo-executions/${executionId}/files/${fileName}`,
			method: 'PUT',
			query: query,
			body: data,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает состояние, из которого в последний раз генерировались шаблоны этого ai-algo execution — то же тело, что принимает POST .../templates, включая поле `kind`, так что клиенту не нужно угадывать форму. 404, если execution не найден или шаблоны для него ещё не генерировались.
	 *
	 * @tags ai-interview
	 * @name GetAiAlgoExecutionCodeGenStateV1
	 * @summary Admin — the spec an ai-algo execution's templates were last generated from
	 * @request GET:/v1/admin/ai-algo-executions/{executionId}/code-gen-state
	 */
	getAiAlgoExecutionCodeGenStateV1 = (
		executionId: string,
		params: RequestParams = {},
	) =>
		this.request<
			AIAlgoTemplatesSpecV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/admin/ai-algo-executions/${executionId}/code-gen-state`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name CreateAiDialogV1
	 * @request POST:/v1/ai-dialogs
	 */
	createAiDialogV1 = (data: CreateAIDialogV1, params: RequestParams = {}) =>
		this.request<CreateAIDialogResponseV1, CreateAIDialog400ErrorResponseV1>({
			path: `/v1/ai-dialogs`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name ListAiDialogsV1
	 * @request GET:/v1/ai-dialogs
	 */
	listAiDialogsV1 = (
		query: {
			status?: AIDialogStatusV1;
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<ListAIDialogsResponseV1, any>({
			path: `/v1/ai-dialogs`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name GetAiDialogV1
	 * @request GET:/v1/ai-dialogs/{id}
	 */
	getAiDialogV1 = (id: string, params: RequestParams = {}) =>
		this.request<GetAIDialogResponseV1, any>({
			path: `/v1/ai-dialogs/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name CreateAiDialogMessageV1
	 * @request POST:/v1/ai-dialogs/{id}/messages
	 */
	createAiDialogMessageV1 = (
		id: string,
		data: PostSendAIDialogMessageV1,
		params: RequestParams = {},
	) =>
		this.request<AIVisibleMessageV1, any>({
			path: `/v1/ai-dialogs/${id}/messages`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name ListAiDialogMessagesV1
	 * @request GET:/v1/ai-dialogs/{id}/messages
	 */
	listAiDialogMessagesV1 = (
		id: string,
		query?: {
			afterMessageId?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<GetAIDialogMessagesResponseV1, any>({
			path: `/v1/ai-dialogs/${id}/messages`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name UpdateAiDialogStatusV1
	 * @summary Update ai-dialog status
	 * @request PATCH:/v1/ai-dialogs/{id}/status
	 */
	updateAiDialogStatusV1 = (
		id: string,
		data: UpdateAIDialogStatusRequestV1,
		params: RequestParams = {},
	) =>
		this.request<OkResponse, UpdateAIDialogStatus400Response>({
			path: `/v1/ai-dialogs/${id}/status`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name CreateAiDialogSubmitV1
	 * @request POST:/v1/ai-dialogs/{id}/problems/{taskId}/submits
	 */
	createAiDialogSubmitV1 = (
		id: string,
		taskId: string,
		data: PostSubmitAIProblemCodeTaskV1,
		params: RequestParams = {},
	) =>
		this.request<AIVisibleMessageV1, SubmitAICode400ErrorResponseV1>({
			path: `/v1/ai-dialogs/${id}/problems/${taskId}/submits`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name CompleteAiStaticTaskV1
	 * @request POST:/v1/ai-dialogs/{id}/static-tasks/{taskId}
	 */
	completeAiStaticTaskV1 = (
		id: string,
		taskId: string,
		params: RequestParams = {},
	) =>
		this.request<
			AIVisibleMessageV1,
			CompleteAITask400ResponseV1 | AIInterviewAlreadyExistsErrorV1
		>({
			path: `/v1/ai-dialogs/${id}/static-tasks/${taskId}`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name CompleteAiSelectTaskV1
	 * @request POST:/v1/ai-dialogs/{id}/select-tasks/{taskId}
	 */
	completeAiSelectTaskV1 = (
		id: string,
		taskId: string,
		data: PostCompleteAISelectTaskV1,
		params: RequestParams = {},
	) =>
		this.request<
			AIVisibleMessageV1,
			CompleteAITask400ResponseV1 | AIInterviewAlreadyExistsErrorV1
		>({
			path: `/v1/ai-dialogs/${id}/select-tasks/${taskId}`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name SubmitAiCodeReviewTaskV1
	 * @request POST:/v1/ai-dialogs/{id}/code-reviews/{taskId}
	 */
	submitAiCodeReviewTaskV1 = (
		id: string,
		taskId: string,
		data: PostSubmitAICodeReviewTaskV1,
		params: RequestParams = {},
	) =>
		this.request<
			AIVisibleMessageV1,
			CompleteAITask400ResponseV1 | AIInterviewAlreadyExistsErrorV1
		>({
			path: `/v1/ai-dialogs/${id}/code-reviews/${taskId}`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags ai-interview
	 * @name CronAiDialogProcessTimeoutsV1
	 * @request POST:/v1/internal/cron/ai-dialogs/process-timeouts
	 */
	cronAiDialogProcessTimeoutsV1 = (params: RequestParams = {}) =>
		this.request<OkResponse, any>({
			path: `/v1/internal/cron/ai-dialogs/process-timeouts`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Ставит задание на генерацию AI-проблемы (ai_problem) с задачами через ИИ. Устаревший backend-only контракт; для новых интеграций используйте MCP authoring flow.
	 *
	 * @tags ai-interview
	 * @name CreateAdminAiProblemV1
	 * @request POST:/v1/admin/ai-problems
	 * @deprecated
	 */
	createAdminAiProblemV1 = (
		data: CreateAdminAIProblemRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			CreateAdminAIProblemResponseV1,
			CreateAdminAIProblem400ResponseV1 | NotAuthorized | AccessDenied
		>({
			path: `/v1/admin/ai-problems`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Получить анкету (список вопросов) по id
	 *
	 * @tags survey
	 * @name GetSurveyV1
	 * @request GET:/v1/surveys/{id}
	 */
	getSurveyV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			SurveyV1,
			NotAuthorized | AccessDenied | SurveyNotFoundResponseV1
		>({
			path: `/v1/surveys/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Получить собственный ответ на анкету
	 *
	 * @tags survey
	 * @name GetOwnSurveyResponseV1
	 * @request GET:/v1/surveys/{id}/responses
	 */
	getOwnSurveyResponseV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			UserSurveyResponseV1,
			NotAuthorized | AccessDenied | ResourceNotFound
		>({
			path: `/v1/surveys/${id}/responses`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Отправить ответ на анкету
	 *
	 * @tags survey
	 * @name SubmitSurveyResponseV1
	 * @request POST:/v1/surveys/{id}/responses
	 */
	submitSurveyResponseV1 = (
		id: string,
		data: SubmitSurveyResponseRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| SurveyAnswerInvalidResponseV1
			| NotAuthorized
			| AccessDenied
			| SurveyNotFoundResponseV1
			| SurveyResponseExistsResponseV1
		>({
			path: `/v1/surveys/${id}/responses`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Создать анкету
	 *
	 * @tags survey
	 * @name CreateSurveyV1
	 * @request POST:/v1/admin/surveys
	 */
	createSurveyV1 = (data: CreateSurveyRequestV1, params: RequestParams = {}) =>
		this.request<
			OkResponse,
			| SurveySchemaInvalidResponseV1
			| NotAuthorized
			| AccessDenied
			| SurveyExistsResponseV1
		>({
			path: `/v1/admin/surveys`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Обновить анкету (разрешено, пока нет ответов)
	 *
	 * @tags survey
	 * @name UpdateSurveyV1
	 * @request PUT:/v1/admin/surveys/{id}
	 */
	updateSurveyV1 = (
		id: string,
		data: UpdateSurveyRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| SurveySchemaInvalidResponseV1
			| NotAuthorized
			| AccessDenied
			| SurveyNotFoundResponseV1
			| SurveyLockedResponseV1
		>({
			path: `/v1/admin/surveys/${id}`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Распределение ответов по анкете
	 *
	 * @tags survey
	 * @name GetSurveyDistributionV1
	 * @request GET:/v1/admin/surveys/{id}/distribution
	 */
	getSurveyDistributionV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			SurveyDistributionV1,
			NotAuthorized | AccessDenied | SurveyNotFoundResponseV1
		>({
			path: `/v1/admin/surveys/${id}/distribution`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Все ответы конкретного пользователя
	 *
	 * @tags survey
	 * @name GetUserSurveysV1
	 * @request GET:/v1/admin/users/{userLogin}/surveys
	 */
	getUserSurveysV1 = (userLogin: string, params: RequestParams = {}) =>
		this.request<UserSurveysV1, NotAuthorized | AccessDenied>({
			path: `/v1/admin/users/${userLogin}/surveys`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Все активные темы, доступные в CRM. Метод предназначен только для CRM-менеджеров и администраторов.
	 *
	 * @tags crm
	 * @name ListCrmInterestTopicsV1
	 * @request GET:/v1/crm/interest-topics
	 */
	listCrmInterestTopicsV1 = (params: RequestParams = {}) =>
		this.request<CRMInterestTopicsResponseV1, NotAuthorized | AccessDenied>({
			path: `/v1/crm/interest-topics`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Упорядоченный справочник стадий единого CRM-процесса. Администратор получает все стадии, CM — только unknown, rejected, lead, warming, qualification и paused.
	 *
	 * @tags crm
	 * @name ListCrmStagesV1
	 * @request GET:/v1/crm/stages
	 */
	listCrmStagesV1 = (params: RequestParams = {}) =>
		this.request<CRMStagesResponseV1, NotAuthorized | AccessDenied>({
			path: `/v1/crm/stages`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Единая коллекционная ручка CRM. Возвращает каноническую карточку одного формата для таблицы, sales-канбана и списка следующих действий; UI отличается только набором фильтров и способом рендера. CM всегда видит только свои карточки на стадиях unknown, rejected, lead, warming, qualification и paused; переданный дальше клиент для CM недоступен. Администратор видит все карточки и может выбирать представление фильтрами.
	 *
	 * @tags crm
	 * @name ListCrmClientsV1
	 * @request GET:/v1/crm/clients
	 */
	listCrmClientsV1 = (
		query: {
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
			dialogStatus?: CRMDialogStatusV1;
			/**
			 * Канонический грейд клиента. До заполнения onboarding имеет значение unknown;
			 * затем заполняется из анкеты и может быть изменён менеджером.
			 */
			clientGrade?: CRMClientGradeV1;
			/** Стабильный optionId направления из onboarding-формы. */
			occupation?: CRMClientOccupationV1;
			/** Стабильный optionId основного языка из onboarding-формы. */
			primaryLanguage?: CRMPrimaryLanguageV1;
			/**
			 * Фильтр по текущему совпадению профиля с целевым сегментом:
			 * Go/Java/Python, Middle/Senior/Lead и собеседования не позднее 2–3 месяцев.
			 */
			salesEligible?: boolean;
			/** Идентификатор из GET /v1/crm/stages. */
			stage?: CRMStageV1;
			entrySource?: CRMEntrySourceV1;
			/** @format date-time */
			currentTaskDueFrom?: string;
			/** @format date-time */
			currentTaskDueTo?: string;
			/** true — дедлайн следующего действия уже прошёл; false — не просрочено или действие не назначено. */
			currentTaskOverdue?: boolean;
			sortBy?: CRMClientSortV1;
			sortOrder?: CRMSortOrderV1;
			activityStatus?: CRMActivityStatusV1;
			/**
			 * Минимальное количество полных дней без активности, включительно
			 * @min 0
			 */
			silentDaysFrom?: number;
			/**
			 * Максимальное количество полных дней без активности, включительно
			 * @min 0
			 */
			silentDaysTo?: number;
			riskStatus?: CRMRiskStatusV1;
			customerStatus?: CRMCustomerStatusV1;
			/**
			 * Минимальное количество полных дней с последней коммуникации, включительно
			 * @min 0
			 */
			lastContactDaysFrom?: number;
			/**
			 * Максимальное количество полных дней с последней коммуникации, включительно
			 * @min 0
			 */
			lastContactDaysTo?: number;
			/** Только для админа: карточки конкретного менеджера */
			managerLogin?: string;
			/** Только для админа: карточки без менеджера */
			unassigned?: boolean;
			/** Поиск по имени, логину, email или Telegram-username клиента */
			search?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<CRMClientListResponseV1, NotAuthorized | AccessDenied>({
			path: `/v1/crm/clients`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Карточка клиента + ответы его onboarding-анкет
	 *
	 * @tags crm
	 * @name GetCrmClientV1
	 * @request GET:/v1/crm/clients/{id}
	 */
	getCrmClientV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			CRMClientDetailsResponseV1,
			NotAuthorized | AccessDenied | CRMClientNotFoundResponseV1
		>({
			path: `/v1/crm/clients/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Обновить поля карточки клиента
	 *
	 * @tags crm
	 * @name UpdateCrmClientV1
	 * @request PATCH:/v1/crm/clients/{id}
	 */
	updateCrmClientV1 = (
		id: string,
		data: UpdateCRMClientRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| CRMValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| CRMClientNotFoundResponseV1
		>({
			path: `/v1/crm/clients/${id}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Скачать текущее резюме клиента. Метод доступен администратору и назначенному менеджеру клиента.
	 *
	 * @tags crm
	 * @name DownloadCrmClientResumeV1
	 * @request GET:/v1/crm/clients/{id}/resume
	 */
	downloadCrmClientResumeV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			File,
			NotAuthorized | AccessDenied | CRMResumeDownloadNotFoundResponseV1
		>({
			path: `/v1/crm/clients/${id}/resume`,
			method: 'GET',
			...params,
		});
	/**
	 * @description Загрузить файл резюме клиента в CRM S3 bucket. Файл сохраняется под уникальным ключом внутри resume/{clientId}/. Метод доступен администратору и назначенному менеджеру клиента.
	 *
	 * @tags crm
	 * @name UploadCrmClientResumeV1
	 * @request POST:/v1/crm/clients/{id}/resume
	 */
	uploadCrmClientResumeV1 = (
		id: string,
		data: {
			/**
			 * Resume file, up to 10 MiB
			 * @format binary
			 * @maxLength 10485760
			 */
			file: File;
		},
		params: RequestParams = {},
	) =>
		this.request<
			CRMResumeV1,
			| CRMValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| CRMClientNotFoundResponseV1
		>({
			path: `/v1/crm/clients/${id}/resume`,
			method: 'POST',
			body: data,
			type: ContentType.FormData,
			format: 'json',
			...params,
		});
	/**
	 * @description Полностью заменить явные настройки топиков клиента. Метод доступен только его CRM-менеджеру и администратору; пользователь напрямую своими топиками не управляет. Фронтенд может предлагать популярный набор, но подписка возникает только после сохранения менеджером. Переданные настройки сохраняются атомарно, отсутствующие удаляются. Повторное сохранение обновляет receivedAt. У клиента обязательно должен быть назначен CRM-менеджер. Автоматическая доставка по включённому топику дополнительно требует активной продуктовой подписки клиента. При переходе interview-топика из выключенного или ненастроенного состояния во включённое для каждого такого топика создаётся отдельная задача менеджеру с дедлайном через 48 часов. Каждое сообщение имеет стабильный messageId, заданный в коде, и может быть поставлено клиенту не более одного раза. Повторное сохранение, отключение и повторное включение топика, завершение исходной задачи или смена менеджера не запускают то же сообщение заново. Новая версия сообщения с новым messageId может быть поставлена отдельно.
	 *
	 * @tags crm
	 * @name ReplaceCrmClientInterestTopicsV1
	 * @request PUT:/v1/crm/clients/{id}/interest-topics
	 */
	replaceCrmClientInterestTopicsV1 = (
		id: string,
		data: ReplaceCRMClientInterestTopicsRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			CRMClientInterestTopicsResponseV1,
			| CRMValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| CRMClientNotFoundResponseV1
			| CRMClientManagerRequiredResponseV1
		>({
			path: `/v1/crm/clients/${id}/interest-topics`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Добавить в рабочую историю клиента активность с обязательным summary
	 *
	 * @tags crm
	 * @name CreateCrmClientActivityV1
	 * @request POST:/v1/crm/clients/{id}/history
	 */
	createCrmClientActivityV1 = (
		id: string,
		data: CreateCRMClientActivityRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| CRMValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| CRMClientNotFoundResponseV1
		>({
			path: `/v1/crm/clients/${id}/history`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Создать ручное следующее действие для назначенного менеджера клиента
	 *
	 * @tags crm
	 * @name CreateCrmManagerTaskV1
	 * @request POST:/v1/crm/clients/{id}/tasks
	 */
	createCrmManagerTaskV1 = (
		id: string,
		data: CreateCRMManagerTaskRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			CRMManagerTaskV1,
			| CRMValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| CRMClientNotFoundResponseV1
			| CRMClientManagerRequiredResponseV1
		>({
			path: `/v1/crm/clients/${id}/tasks`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Изменить название, описание или дедлайн активной CRM-задачи
	 *
	 * @tags crm
	 * @name UpdateCrmManagerTaskV1
	 * @request PATCH:/v1/crm/tasks/{id}
	 */
	updateCrmManagerTaskV1 = (
		id: string,
		data: UpdateCRMManagerTaskRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| CRMValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound404ResponseV1
		>({
			path: `/v1/crm/tasks/${id}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Обновить статус CRM-задачи. Завершение подтверждает ручную отправку подготовленного сообщения студенту
	 *
	 * @tags crm
	 * @name UpdateCrmManagerTaskStatusV1
	 * @request PATCH:/v1/crm/tasks/{id}/status
	 */
	updateCrmManagerTaskStatusV1 = (
		id: string,
		data: UpdateCRMManagerTaskStatusRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| CRMValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound404ResponseV1
		>({
			path: `/v1/crm/tasks/${id}/status`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Список CRM-задач. CM видит только свои задачи по клиентам на стадиях unknown, rejected, lead, warming, qualification и paused; администратор — все.
	 *
	 * @tags crm
	 * @name ListCrmManagerTasksV1
	 * @request GET:/v1/crm/tasks
	 */
	listCrmManagerTasksV1 = (
		query: {
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
			id?: string;
			/** Фильтр задач по идентификатору CRM-карточки клиента */
			crmClientId?: string;
			studentUserId?: string;
			studentLogin?: string;
			type?: CRMTaskTypeV1;
			/** Только для админа */
			managerUserId?: string;
			/** Только для админа */
			managerLogin?: string;
			/** @format uuid */
			aiOutboxEventId?: string;
			status?: CRMTaskStatusV1;
			/** Поиск подстроки без учёта регистра */
			title?: string;
			/** Поиск подстроки без учёта регистра */
			descriptionMd?: string;
			/** @format date-time */
			createdAtFrom?: string;
			/** @format date-time */
			createdAtTo?: string;
			/** @format date-time */
			deadlineAtFrom?: string;
			/** @format date-time */
			deadlineAtTo?: string;
			/** @format date-time */
			completedAtFrom?: string;
			/** @format date-time */
			completedAtTo?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			CRMManagerTasksResponseV1,
			CRMValidationFailedResponseV1 | NotAuthorized | AccessDenied
		>({
			path: `/v1/crm/tasks`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Ошибки автоматической генерации CRM-сообщений для клиента
	 *
	 * @tags crm
	 * @name ListCrmAutomationEventsV1
	 * @request GET:/v1/crm/clients/{id}/automation-events
	 */
	listCrmAutomationEventsV1 = (
		id: string,
		query: {
			status: CRMAutomationEventStatusV1;
		},
		params: RequestParams = {},
	) =>
		this.request<
			CRMAutomationEventsResponseV1,
			| CRMValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| CRMClientNotFoundResponseV1
		>({
			path: `/v1/crm/clients/${id}/automation-events`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Повторно поставить упавшее событие автоматической CRM-генерации в AI outbox
	 *
	 * @tags crm
	 * @name RetryCrmAutomationEventV1
	 * @request POST:/v1/crm/automation-events/{id}/retry
	 */
	retryCrmAutomationEventV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			OkResponse,
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound404ResponseV1
			| CRMAutomationNotRetryableResponseV1
		>({
			path: `/v1/crm/automation-events/${id}/retry`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Список событий AI outbox. Администратор и редактор могут просматривать все события и при необходимости фильтровать их по userLogin.
	 *
	 * @tags admin
	 * @name ListAdminAiOutboxEventsV1
	 * @request GET:/v1/admin/ai-outbox/events
	 */
	listAdminAiOutboxEventsV1 = (
		query: {
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
			/** @format uuid */
			id?: string;
			eventType?: string;
			userLogin?: string;
			status?: AIOutboxStatusV1;
			/** @format date-time */
			createdAtFrom?: string;
			/** @format date-time */
			createdAtTo?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			AIOutboxEventsResponseV1,
			AIOutboxValidationFailedResponseV1 | NotAuthorized | AccessDenied
		>({
			path: `/v1/admin/ai-outbox/events`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Лид-скоринг клиента с фильтром по дате и пагинацией
	 *
	 * @tags crm
	 * @name GetCrmClientLeadScoringV1
	 * @request GET:/v1/crm/clients/{id}/lead-scoring
	 */
	getCrmClientLeadScoringV1 = (
		id: string,
		query: {
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
			/**
			 * Нижняя граница периода (включительно)
			 * @format date-time
			 */
			dateFrom?: string;
			/**
			 * Верхняя граница периода (включительно)
			 * @format date-time
			 */
			dateTo?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			CRMClientLeadScoringResponseV1,
			NotAuthorized | AccessDenied | CRMClientNotFoundResponseV1
		>({
			path: `/v1/crm/clients/${id}/lead-scoring`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Сабмиты клиента с фильтром по дате и пагинацией
	 *
	 * @tags crm
	 * @name GetCrmClientSubmissionsV1
	 * @request GET:/v1/crm/clients/{id}/submissions
	 */
	getCrmClientSubmissionsV1 = (
		id: string,
		query: {
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
			/**
			 * Нижняя граница периода (включительно)
			 * @format date-time
			 */
			dateFrom?: string;
			/**
			 * Верхняя граница периода (включительно)
			 * @format date-time
			 */
			dateTo?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			CRMClientSubmissionsResponseV1,
			NotAuthorized | AccessDenied | CRMClientNotFoundResponseV1
		>({
			path: `/v1/crm/clients/${id}/submissions`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Детали конкретного сабмита CRM-клиента с кодом и AI-разбором
	 *
	 * @tags crm
	 * @name GetCrmClientSubmissionV1
	 * @request GET:/v1/crm/clients/{id}/submissions/{submissionId}
	 */
	getCrmClientSubmissionV1 = (
		id: string,
		submissionId: string,
		params: RequestParams = {},
	) =>
		this.request<
			CRMSubmissionV1,
			NotAuthorized | AccessDenied | CRMClientNotFoundResponseV1
		>({
			path: `/v1/crm/clients/${id}/submissions/${submissionId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Вручную запустить генерацию отчёта по прогрессу клиента. Backend автоматически выбирает до 20 последних уникальных успешно решённых алгоритмических задач по сабмитам за последние 30 дней. После генерации создаётся CRM-задача с готовым сообщением и дедлайном через 24 часа. Пока предыдущая генерация или задача на отправку отчёта не завершена, повторный запуск для того же клиента отклоняется.
	 *
	 * @tags crm
	 * @name CreateCrmaiReportMessageV1
	 * @request POST:/v1/crm/clients/{id}/ai-report-messages
	 */
	createCrmaiReportMessageV1 = (id: string, params: RequestParams = {}) =>
		this.request<
			CRMProgressReportGenerationResponseV1,
			| NotAuthorized
			| AccessDenied
			| CRMClientNotFoundResponseV1
			| CRMProgressReportConflictResponseV1
		>({
			path: `/v1/crm/clients/${id}/ai-report-messages`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Прохождения теории и сабмиты пользователя в одной ленте, от новых к старым
	 *
	 * @tags algorithms
	 * @name GetUserActivityV1
	 * @request GET:/v1/users/activity
	 */
	getUserActivityV1 = (
		query: {
			userId: string;
			/** Фильтр по категории; если не передан, возвращаются события всех категорий */
			category?: ProblemCategoryEnum;
			activityType?: UserActivityTypeFilterEnum;
			submissionResult?: UserActivitySubmissionResultFilterEnum;
			/** Фильтр по наличию AI-разбора; если задан, события теории исключаются */
			hasAiReport?: boolean;
			/** Opaque cursor returned as nextCursor by the previous page */
			cursor?: string;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
			/**
			 * Нижняя граница периода (включительно)
			 * @format date-time
			 */
			dateFrom?: string;
			/**
			 * Верхняя граница периода (включительно)
			 * @format date-time
			 */
			dateTo?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			UserActivityResponseV1,
			| UserActivityValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound404ResponseV1
		>({
			path: `/v1/users/activity`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Количество прохождений теории и сабмитов пользователя по дням за период не более 90 календарных дней
	 *
	 * @tags algorithms
	 * @name GetUserActivityDailyV1
	 * @request GET:/v1/users/daily-activity
	 */
	getUserActivityDailyV1 = (
		query: {
			userId: string;
			/** Фильтр по категории; если не передан, учитываются события всех категорий */
			category?: ProblemCategoryEnum;
			activityType?: UserActivityTypeFilterEnum;
			submissionResult?: UserActivitySubmissionResultFilterEnum;
			/** Фильтр по наличию AI-разбора; если задан, события теории исключаются */
			hasAiReport?: boolean;
			/**
			 * Нижняя граница периода (включительно)
			 * @format date-time
			 */
			dateFrom: string;
			/**
			 * Верхняя граница периода (включительно); период содержит не более 90 календарных дней
			 * @format date-time
			 */
			dateTo: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			UserActivityDailyResponseV1,
			| UserActivityValidationFailedResponseV1
			| NotAuthorized
			| AccessDenied
			| ResourceNotFound404ResponseV1
		>({
			path: `/v1/users/daily-activity`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Назначить или переназначить менеджера карточки. Активные задачи переходят новому менеджеру, завершённые сохраняют прежнего исполнителя.
	 *
	 * @tags crm
	 * @name AssignCrmClientManagerV1
	 * @request PUT:/v1/admin/crm/clients/{id}/manager
	 */
	assignCrmClientManagerV1 = (
		id: string,
		data: AssignCRMClientManagerRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			OkResponse,
			| CRMInvalidManagerResponseV1
			| NotAuthorized
			| AccessDenied
			| CRMClientNotFoundResponseV1
		>({
			path: `/v1/admin/crm/clients/${id}/manager`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Список комьюнити-менеджеров с общим числом закреплённых карточек
	 *
	 * @tags crm
	 * @name ListCrmManagersV1
	 * @request GET:/v1/admin/crm/managers
	 */
	listCrmManagersV1 = (params: RequestParams = {}) =>
		this.request<CRMManagerListResponseV1, NotAuthorized | AccessDenied>({
			path: `/v1/admin/crm/managers`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Проверяет пользовательские учётные данные для OAuth-сервиса.
	 *
	 * @tags accounts
	 * @name VerifyOAuthCredentialsInternalV1
	 * @request POST:/v1/internal/auth/verify-credentials
	 */
	verifyOAuthCredentialsInternalV1 = (
		data: InternalVerifyCredentialsRequestV1,
		params: RequestParams = {},
	) =>
		this.request<InternalVerifyCredentialsResponseV1, InternalErrorV1>({
			path: `/v1/internal/auth/verify-credentials`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Returns individual feedback records for the current delegated admin. Filters apply before pagination.
	 *
	 * @tags feedback
	 * @name ListFeedbacksInternalV1
	 * @request GET:/v1/internal/content/feedbacks
	 */
	listFeedbacksInternalV1 = (
		query: {
			/**
			 * @minLength 1
			 * @maxLength 256
			 */
			problem_id?: string;
			/** @pattern ^[0-9A-Fa-f]{32}$ */
			theory_id?: string;
			/**
			 * 1–50 Unicode characters after trimming whitespace; case preserved.
			 * @minLength 1
			 */
			ai_problem_id?: string;
			/** @default "all" */
			status?: 'all' | 'solved' | 'unsolved';
			/** @default "all" */
			type?: 'all' | 'error' | 'improvement';
			/** @min 0 */
			offset: number;
			/**
			 * @min 1
			 * @max 100
			 */
			limit: number;
		},
		params: RequestParams = {},
	) =>
		this.request<
			InternalFeedbackListV1,
			InvalidFeedbackInputV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/feedbacks`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Returns the exact stored feedback dialog; never the current attempt.
	 *
	 * @tags feedback
	 * @name GetFeedbackDialogInternalV1
	 * @request GET:/v1/internal/content/feedbacks/{feedbackID}/dialog
	 */
	getFeedbackDialogInternalV1 = (
		feedbackId: string,
		params: RequestParams = {},
	) =>
		this.request<
			InternalFeedbackDialogV1,
			| InvalidFeedbackInputV1
			| InternalErrorV1
			| FeedbackNotFoundV1
			| FeedbackContextUnavailableV1
		>({
			path: `/v1/internal/content/feedbacks/${feedbackId}/dialog`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Idempotently marks one feedback solved for the current delegated admin.
	 *
	 * @tags feedback
	 * @name ResolveFeedbackInternalV1
	 * @request POST:/v1/internal/content/feedbacks/{feedbackID}/resolve
	 */
	resolveFeedbackInternalV1 = (
		feedbackId: string,
		params: RequestParams = {},
	) =>
		this.request<
			InternalFeedbackResolveV1,
			InvalidFeedbackInputV1 | InternalErrorV1 | FeedbackNotFoundV1
		>({
			path: `/v1/internal/content/feedbacks/${feedbackId}/resolve`,
			method: 'POST',
			format: 'json',
			...params,
		});
	/**
	 * @description Административный поиск обычных задач, статей и AI-материалов. Курсы объединяются по OR; tag_match выбирает any (по умолчанию) или all. Обычные статьи не имеют тегов и исключаются при непустом tag_ids. Фильтры применяются до общей пагинации. Уникальность результата — type и id. Для полной выборки читать страницы до offset + items.length >= total.
	 *
	 * @tags content
	 * @name SearchContentInternalV1
	 * @request GET:/v1/internal/content/search
	 */
	searchContentInternalV1 = (
		query?: {
			/** @maxLength 256 */
			query?: string;
			/**
			 * @maxItems 100
			 * @uniqueItems true
			 */
			course_ids?: string[];
			/**
			 * @maxItems 100
			 * @uniqueItems true
			 */
			tag_ids?: string[];
			/**
			 * @maxItems 6
			 * @uniqueItems true
			 */
			types?: ContentSearchTypeV1[];
			/** @default "any" */
			tag_match?: 'any' | 'all';
			/**
			 * @min 0
			 * @default 0
			 */
			offset?: number;
			/**
			 * @min 1
			 * @max 100
			 * @default 20
			 */
			limit?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<ContentSearchResponseV1, InternalErrorV1>({
			path: `/v1/internal/content/search`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает краткие карточки AI-интервью для поиска и дедупликации.
	 *
	 * @tags ai-interview
	 * @name ListAiInterviewsInternalV1
	 * @request GET:/v1/internal/content/ai-interviews
	 */
	listAiInterviewsInternalV1 = (
		query?: {
			query?: string;
			type?: AIProblemTypeV1;
			is_visible?: boolean;
			is_free?: boolean;
			/** @min 1 */
			language_id?: number;
			course_id?: string;
			/** @default "any" */
			usage?: 'any' | 'used' | 'unused';
			/**
			 * @min 0
			 * @default 0
			 */
			offset?: number;
			/**
			 * @min 1
			 * @max 100
			 * @default 20
			 */
			limit?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<InternalAIInterviewListResponseV1, InternalErrorV1>({
			path: `/v1/internal/content/ai-interviews`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Полностью валидирует CreateCandidate и синхронно создаёт скрытую AI-задачу.
	 *
	 * @tags ai-interview
	 * @name CreateAiProblemInternalV1
	 * @request POST:/v1/internal/content/ai-interviews
	 */
	createAiProblemInternalV1 = (
		data: InternalAIProblemCreateEnvelopeV1,
		params: RequestParams = {},
	) =>
		this.request<InternalAIProblemCreateResultV1, InternalErrorV1>({
			path: `/v1/internal/content/ai-interviews`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает полную редакторскую запись AI-интервью.
	 *
	 * @tags ai-interview
	 * @name GetAiInterviewInternalV1
	 * @request GET:/v1/internal/content/ai-interviews/{id}
	 */
	getAiInterviewInternalV1 = (id: string, params: RequestParams = {}) =>
		this.request<GetAdminAIProblemResponseV1, InternalErrorV1>({
			path: `/v1/internal/content/ai-interviews/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Частично изменяет метаданные и атомарно применяет add/update/remove/order к шагам.
	 *
	 * @tags ai-interview
	 * @name PatchAiProblemInternalV1
	 * @request PATCH:/v1/internal/content/ai-interviews/{id}
	 */
	patchAiProblemInternalV1 = (
		id: string,
		data: InternalAIProblemPatchV1,
		params: RequestParams = {},
	) =>
		this.request<InternalAIProblemPatchResultV1, InternalErrorV1>({
			path: `/v1/internal/content/ai-interviews/${id}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает последнюю попытку интервью пользователя со всеми диалогами для оценки. Доступно только администраторам.
	 *
	 * @tags ai-interview
	 * @name GetCandidateInterviewResultInternalV1
	 * @request GET:/v1/internal/content/candidate-interviews/{id}/results/{userLogin}
	 */
	getCandidateInterviewResultInternalV1 = (
		id: string,
		userLogin: string,
		query?: {
			attempt_id?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<InternalCandidateInterviewResultV1, InternalErrorV1>({
			path: `/v1/internal/content/candidate-interviews/${id}/results/${userLogin}`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает полный результат диалога пользователя по AI-задаче. Доступно только администраторам.
	 *
	 * @tags ai-interview
	 * @name GetAiInterviewDialogResultInternalV1
	 * @request GET:/v1/internal/content/ai-interviews/{id}/dialog-results/{userLogin}
	 */
	getAiInterviewDialogResultInternalV1 = (
		id: string,
		userLogin: string,
		params: RequestParams = {},
	) =>
		this.request<InternalAIDialogResultV1, InternalErrorV1>({
			path: `/v1/internal/content/ai-interviews/${id}/dialog-results/${userLogin}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает актуальные правила авторинга AI-задач.
	 *
	 * @tags ai-interview
	 * @name GetAiProblemAuthoringGuideInternalV1
	 * @request GET:/v1/internal/content/ai-interviews/authoring-guide
	 */
	getAiProblemAuthoringGuideInternalV1 = (
		query?: {
			problem_type?: 'ai-theory' | 'ai-practice';
			schema_version?: string;
			guide_version?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<InternalAIProblemAuthoringGuideV1, InternalErrorV1>({
			path: `/v1/internal/content/ai-interviews/authoring-guide`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Синхронно создаёт независимые валидные элементы batch.
	 *
	 * @tags ai-interview
	 * @name CreateAiProblemBatchInternalV1
	 * @request POST:/v1/internal/content/ai-interviews/batch
	 */
	createAiProblemBatchInternalV1 = (
		data: InternalAIProblemBatchCreateEnvelopeV1,
		params: RequestParams = {},
	) =>
		this.request<InternalAIProblemBatchCreateResultV1, InternalErrorV1>({
			path: `/v1/internal/content/ai-interviews/batch`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает справочник компаний для поиска и дедупликации перед созданием.
	 *
	 * @tags algorithms
	 * @name ListCompaniesInternalV1
	 * @request GET:/v1/internal/content/companies
	 */
	listCompaniesInternalV1 = (
		query?: {
			query?: string;
			/**
			 * @min 0
			 * @default 0
			 */
			offset?: number;
			/**
			 * @min 1
			 * @max 100
			 * @default 100
			 */
			limit?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<InternalCompanyListResponseV1, InternalErrorV1>({
			path: `/v1/internal/content/companies`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Создаёт новую компанию с явно заданным неизменяемым ID; upsert и автосуффиксы запрещены.
	 *
	 * @tags algorithms
	 * @name CreateCompanyInternalV1
	 * @request POST:/v1/internal/content/companies
	 */
	createCompanyInternalV1 = (
		data: InternalCompanyCreateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			InternalCompanyV1,
			InternalErrorV1 | InternalCompanyConflictResponseV1
		>({
			path: `/v1/internal/content/companies`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Переименовывает компанию; стабильный ID изменить нельзя.
	 *
	 * @tags algorithms
	 * @name PatchCompanyInternalV1
	 * @request PATCH:/v1/internal/content/companies/{companyId}
	 */
	patchCompanyInternalV1 = (
		companyId: string,
		data: InternalCompanyPatchRequestV1,
		params: RequestParams = {},
	) =>
		this.request<InternalCompanyV1, InternalErrorV1>({
			path: `/v1/internal/content/companies/${companyId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Удаляет только неиспользуемую компанию.
	 *
	 * @tags algorithms
	 * @name DeleteCompanyInternalV1
	 * @request DELETE:/v1/internal/content/companies/{companyId}
	 */
	deleteCompanyInternalV1 = (companyId: string, params: RequestParams = {}) =>
		this.request<void, InternalErrorV1>({
			path: `/v1/internal/content/companies/${companyId}`,
			method: 'DELETE',
			...params,
		});
	/**
	 * @description Возвращает краткие карточки обычных задач для поиска через MCP.
	 *
	 * @tags algorithms
	 * @name ListProblemsInternalV1
	 * @request GET:/v1/internal/content/problems
	 */
	listProblemsInternalV1 = (
		query?: {
			query?: string;
			category?: ProblemCategoryEnum;
			/** Точный стабильный company.id. */
			company?: string;
			is_visible?: boolean;
			is_free?: boolean;
			course_id?: string;
			/**
			 * @min 0
			 * @default 0
			 */
			offset?: number;
			/**
			 * @min 1
			 * @max 100
			 * @default 20
			 */
			limit?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<InternalProblemListResponseV1, InternalErrorV1>({
			path: `/v1/internal/content/problems`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает полную редакторскую запись обычной задачи для MCP.
	 *
	 * @tags algorithms
	 * @name GetProblemInternalV1
	 * @request GET:/v1/internal/content/problems/{problemId}
	 */
	getProblemInternalV1 = (
		problemId: string,
		query?: {
			/** @default false */
			include_editor?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<
			InternalProblemDetailV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/problems/${problemId}`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Частично сохраняет классическую задачу с проверкой версии, включая разбор и стартовый код опубликованной задачи. Видимость меняется только при явном is_visible. Публикация скрытой задачи проверяет эталонные решения.
	 *
	 * @tags algorithms
	 * @name PatchProblemInternalV1
	 * @request PATCH:/v1/internal/content/problems/{problemId}
	 */
	patchProblemInternalV1 = (
		problemId: string,
		data: InternalProblemPatchRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			InternalProblemWriteResultV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/problems/${problemId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Атомарно заменяет компании задачи по стабильным company.id. Если задача существует одновременно в обычном и AI Algo контурах, обе таблицы обновляются в одной транзакции; пустой список очищает связи.
	 *
	 * @tags algorithms
	 * @name UpdateProblemInternalV1
	 * @request PUT:/v1/internal/content/problems/{problemId}
	 */
	updateProblemInternalV1 = (
		problemId: string,
		data: InternalProblemUpdateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<InternalProblemCompaniesResponseV1, InternalErrorV1>({
			path: `/v1/internal/content/problems/${problemId}`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Проверяет сохранённые или черновые решения, не создавая пользовательских посылок и не меняя прогресс.
	 *
	 * @tags algorithms
	 * @name CheckProblemSolutionsInternalV1
	 * @request POST:/v1/internal/content/problems/{problemId}/solutions/check
	 */
	checkProblemSolutionsInternalV1 = (
		problemId: string,
		data: InternalProblemSolutionsCheckRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			InternalProblemSolutionsCheckResultV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/problems/${problemId}/solutions/check`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Edits only AI algorithm card fields using a persisted-content revision. Dialogue scenario and execution binding are immutable.
	 *
	 * @tags algorithms
	 * @name PatchAiAlgoInternalV1
	 * @request PATCH:/v1/internal/content/ai-algo-problems/{aiProblemId}
	 */
	patchAiAlgoInternalV1 = (
		aiProblemId: string,
		data: InternalAIAlgoCardUpdateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			InternalAIAlgoCardUpdateResultV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/ai-algo-problems/${aiProblemId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Reads the complete editable AI algorithm card and persisted-content revision.
	 *
	 * @tags algorithms
	 * @name GetAiAlgoInternalV1
	 * @request GET:/v1/internal/content/ai-algo-problems/{aiProblemId}
	 */
	getAiAlgoInternalV1 = (aiProblemId: string, params: RequestParams = {}) =>
		this.request<
			InternalAIAlgoCardV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/ai-algo-problems/${aiProblemId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Regenerates six function template archives using revision and storage CAS; preserves manual starters. Shared AI archives require allow_shared; classic consumers block writes.
	 *
	 * @tags algorithms
	 * @name UpdateAiAlgoTemplateInternalV1
	 * @request PUT:/v1/internal/content/ai-algo-problems/{aiProblemId}/template
	 */
	updateAiAlgoTemplateInternalV1 = (
		aiProblemId: string,
		data: InternalAIAlgoTemplateUpdateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			InternalAIAlgoTemplateUpdateResultV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/ai-algo-problems/${aiProblemId}/template`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Reads the selected AI function signature, revision, archive consumers and manual starter rows.
	 *
	 * @tags algorithms
	 * @name GetAiAlgoTemplateInternalV1
	 * @request GET:/v1/internal/content/ai-algo-problems/{aiProblemId}/template
	 */
	getAiAlgoTemplateInternalV1 = (
		aiProblemId: string,
		query?: {
			/**
			 * @minLength 1
			 * @maxLength 50
			 */
			execution_id?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			InternalAIAlgoTemplateSnapshotV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/ai-algo-problems/${aiProblemId}/template`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Replaces only the selected reachable AI execution tests document using revision and storage CAS. Shared objects require allow_shared.
	 *
	 * @tags algorithms
	 * @name UpdateAiAlgoTestsInternalV1
	 * @request PUT:/v1/internal/content/ai-algo-problems/{aiProblemId}/tests
	 */
	updateAiAlgoTestsInternalV1 = (
		aiProblemId: string,
		data: InternalAIAlgoTestsUpdateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			InternalAIAlgoTestsUpdateResultV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/ai-algo-problems/${aiProblemId}/tests`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Reads the actual selected AI execution tests document and its reader set.
	 *
	 * @tags algorithms
	 * @name GetAiAlgoTestsInternalV1
	 * @request GET:/v1/internal/content/ai-algo-problems/{aiProblemId}/tests
	 */
	getAiAlgoTestsInternalV1 = (
		aiProblemId: string,
		query?: {
			/**
			 * @minLength 1
			 * @maxLength 50
			 */
			execution_id?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<
			InternalAIAlgoTestsSnapshotV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/ai-algo-problems/${aiProblemId}/tests`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Replaces only the complete tests.json document using version, inventory revision and storage CAS. Does not execute solutions.
	 *
	 * @tags algorithms
	 * @name UpdateProblemTestsInternalV1
	 * @request PUT:/v1/internal/content/problems/{problemId}/tests
	 */
	updateProblemTestsInternalV1 = (
		problemId: string,
		data: InternalProblemTestsUpdateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			InternalProblemTestsUpdateResultV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/problems/${problemId}/tests`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Reads a coherent uncached tests.json document and fixture inventory revision.
	 *
	 * @tags algorithms
	 * @name GetProblemTestsInternalV1
	 * @request GET:/v1/internal/content/problems/{problemId}/tests
	 */
	getProblemTestsInternalV1 = (problemId: string, params: RequestParams = {}) =>
		this.request<
			InternalProblemTestsSnapshotV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/problems/${problemId}/tests`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Перегенерирует функциональные шаблоны классической задачи для шести языков, включая опубликованные задачи. Заменяет архивы и стартовый код; не меняет видимость, тесты и разбор. Ошибка после записи файлов может быть частичной, такой запрос нельзя автоматически повторять.
	 *
	 * @tags algorithms
	 * @name UpdateProblemTemplateInternalV1
	 * @request PUT:/v1/internal/content/problems/{problemId}/template
	 */
	updateProblemTemplateInternalV1 = (
		problemId: string,
		data: InternalProblemTemplateUpdateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<
			InternalProblemTemplateUpdateResultV1,
			InternalProblemAuthoringErrorV1 | InternalErrorV1
		>({
			path: `/v1/internal/content/problems/${problemId}/template`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает редакторский каталог курсов со стабильной пагинацией по title и id.
	 *
	 * @tags courses
	 * @name ListCoursesInternalV1
	 * @request GET:/v1/internal/content/courses
	 */
	listCoursesInternalV1 = (
		query?: {
			query?: string;
			is_visible?: boolean;
			/**
			 * @min 0
			 * @default 0
			 */
			offset?: number;
			/**
			 * @min 1
			 * @max 100
			 * @default 20
			 */
			limit?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<InternalCourseListResponseV1, InternalCourseErrorV1>({
			path: `/v1/internal/content/courses`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Атомарно создаёт один скрытый курс версии 1; пустой plans допустим.
	 *
	 * @tags courses
	 * @name CreateCourseInternalV1
	 * @request POST:/v1/internal/content/courses
	 */
	createCourseInternalV1 = (
		data: InternalCourseCreateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<InternalCourseV1, InternalCourseErrorV1>({
			path: `/v1/internal/content/courses`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает точную сохранённую конфигурацию курса без пользовательского прогресса.
	 *
	 * @tags courses
	 * @name GetCourseInternalV1
	 * @request GET:/v1/internal/content/courses/{courseId}
	 */
	getCourseInternalV1 = (courseId: string, params: RequestParams = {}) =>
		this.request<InternalCourseV1, InternalCourseErrorV1>({
			path: `/v1/internal/content/courses/${courseId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Частично изменяет метаданные и полностью заменяет plans с optimistic locking.
	 *
	 * @tags courses
	 * @name PatchCourseInternalV1
	 * @request PATCH:/v1/internal/content/courses/{courseId}
	 */
	patchCourseInternalV1 = (
		courseId: string,
		data: InternalCourseUpdateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<InternalCourseUpdateResultV1, InternalCourseErrorV1>({
			path: `/v1/internal/content/courses/${courseId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает редакторский каталог roadmap со стабильной пагинацией по name и id.
	 *
	 * @tags roadmaps
	 * @name ListRoadmapsInternalV1
	 * @request GET:/v1/internal/content/roadmaps
	 */
	listRoadmapsInternalV1 = (
		query?: {
			query?: string;
			is_visible?: boolean;
			/**
			 * @min 0
			 * @default 0
			 */
			offset?: number;
			/**
			 * @min 1
			 * @max 100
			 * @default 20
			 */
			limit?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<InternalRoadmapListResponseV1, InternalRoadmapErrorV1>({
			path: `/v1/internal/content/roadmaps`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * @description Атомарно создаёт один скрытый roadmap версии 1; пустой groups допустим.
	 *
	 * @tags roadmaps
	 * @name CreateRoadmapInternalV1
	 * @request POST:/v1/internal/content/roadmaps
	 */
	createRoadmapInternalV1 = (
		data: InternalRoadmapCreateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<InternalRoadmapV1, InternalRoadmapErrorV1>({
			path: `/v1/internal/content/roadmaps`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * @description Возвращает точную сохранённую конфигурацию roadmap без пользовательского прогресса.
	 *
	 * @tags roadmaps
	 * @name GetRoadmapInternalV1
	 * @request GET:/v1/internal/content/roadmaps/{roadmapId}
	 */
	getRoadmapInternalV1 = (roadmapId: string, params: RequestParams = {}) =>
		this.request<InternalRoadmapV1, InternalRoadmapErrorV1>({
			path: `/v1/internal/content/roadmaps/${roadmapId}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * @description Частично изменяет метаданные и полностью заменяет groups с optimistic locking.
	 *
	 * @tags roadmaps
	 * @name PatchRoadmapInternalV1
	 * @request PATCH:/v1/internal/content/roadmaps/{roadmapId}
	 */
	patchRoadmapInternalV1 = (
		roadmapId: string,
		data: InternalRoadmapUpdateRequestV1,
		params: RequestParams = {},
	) =>
		this.request<InternalRoadmapUpdateResultV1, InternalRoadmapErrorV1>({
			path: `/v1/internal/content/roadmaps/${roadmapId}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name ListTagTypesInternalV1
	 * @request GET:/v1/internal/content/tag-types
	 */
	listTagTypesInternalV1 = (
		query?: {
			query?: string;
			offset?: number;
			limit?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<ProblemTagTypeListV1, ProblemTagErrorV1>({
			path: `/v1/internal/content/tag-types`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name CreateTagTypeInternalV1
	 * @request POST:/v1/internal/content/tag-types
	 */
	createTagTypeInternalV1 = (
		data: ProblemTagTypeCreateV1,
		params: RequestParams = {},
	) =>
		this.request<ProblemTagTypeV1, ProblemTagErrorV1>({
			path: `/v1/internal/content/tag-types`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name UpdateTagTypeInternalV1
	 * @request PATCH:/v1/internal/content/tag-types/{id}
	 */
	updateTagTypeInternalV1 = (
		id: string,
		data: ProblemTagTypeUpdateV1,
		params: RequestParams = {},
	) =>
		this.request<ProblemTagTypeV1, ProblemTagErrorV1>({
			path: `/v1/internal/content/tag-types/${id}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name ListTagsInternalV1
	 * @request GET:/v1/internal/content/tags
	 */
	listTagsInternalV1 = (
		query?: {
			query?: string;
			offset?: number;
			limit?: number;
			type?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ProblemTagListV1, ProblemTagErrorV1>({
			path: `/v1/internal/content/tags`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name CreateTagInternalV1
	 * @request POST:/v1/internal/content/tags
	 */
	createTagInternalV1 = (
		data: ProblemTagCreateV1,
		params: RequestParams = {},
	) =>
		this.request<ProblemTagV1, ProblemTagErrorV1>({
			path: `/v1/internal/content/tags`,
			method: 'POST',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name UpdateTagInternalV1
	 * @request PATCH:/v1/internal/content/tags/{id}
	 */
	updateTagInternalV1 = (
		id: string,
		data: ProblemTagUpdateV1,
		params: RequestParams = {},
	) =>
		this.request<ProblemTagV1, ProblemTagErrorV1>({
			path: `/v1/internal/content/tags/${id}`,
			method: 'PATCH',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name GetTagInternalV1
	 * @request GET:/v1/internal/content/tags/{id}
	 */
	getTagInternalV1 = (id: string, params: RequestParams = {}) =>
		this.request<ProblemTagV1, ProblemTagErrorV1>({
			path: `/v1/internal/content/tags/${id}`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name DeleteTagInternalV1
	 * @request DELETE:/v1/internal/content/tags/{id}
	 */
	deleteTagInternalV1 = (
		id: string,
		query: {
			/** @min 1 */
			expected_version: number;
		},
		params: RequestParams = {},
	) =>
		this.request<void, ProblemTagErrorV1>({
			path: `/v1/internal/content/tags/${id}`,
			method: 'DELETE',
			query: query,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name GetAiProblemTagsInternalV1
	 * @request GET:/v1/internal/content/ai-problems/{id}/tags
	 */
	getAiProblemTagsInternalV1 = (id: string, params: RequestParams = {}) =>
		this.request<AIProblemTagsV1, ProblemTagErrorV1>({
			path: `/v1/internal/content/ai-problems/${id}/tags`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name ReplaceAiProblemTagsInternalV1
	 * @request PUT:/v1/internal/content/ai-problems/{id}/tags
	 */
	replaceAiProblemTagsInternalV1 = (
		id: string,
		data: AIProblemTagsReplaceV1,
		params: RequestParams = {},
	) =>
		this.request<AIProblemTagsV1, ProblemTagErrorV1>({
			path: `/v1/internal/content/ai-problems/${id}/tags`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name ListTagsAdminV1
	 * @request GET:/v1/admin/tags
	 */
	listTagsAdminV1 = (
		query?: {
			query?: string;
			offset?: number;
			limit?: number;
			type?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ProblemTagListV1, ProblemTagErrorV1>({
			path: `/v1/admin/tags`,
			method: 'GET',
			query: query,
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name GetAiProblemTagsAdminV1
	 * @request GET:/v1/admin/ai-problems/{id}/tags
	 */
	getAiProblemTagsAdminV1 = (id: string, params: RequestParams = {}) =>
		this.request<AIProblemTagsV1, ProblemTagErrorV1>({
			path: `/v1/admin/ai-problems/${id}/tags`,
			method: 'GET',
			format: 'json',
			...params,
		});
	/**
	 * No description
	 *
	 * @tags problem-tags
	 * @name ReplaceAiProblemTagsAdminV1
	 * @request PUT:/v1/admin/ai-problems/{id}/tags
	 */
	replaceAiProblemTagsAdminV1 = (
		id: string,
		data: AIProblemTagsReplaceV1,
		params: RequestParams = {},
	) =>
		this.request<AIProblemTagsV1, ProblemTagErrorV1>({
			path: `/v1/admin/ai-problems/${id}/tags`,
			method: 'PUT',
			body: data,
			type: ContentType.Json,
			format: 'json',
			...params,
		});
}
